function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 12 12",
  fill: "none",
  id: "Union"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.238694 10.6081C-0.0795643 10.9263 -0.0795644 11.4423 0.238694 11.7605C0.556874 12.0786 1.07268 12.0786 1.39086 11.7605L6.00046 7.15171L10.6101 11.7605C10.9282 12.0786 11.444 12.0786 11.7622 11.7605C12.0805 11.4423 12.0805 10.9263 11.7622 10.6081L7.15283 5.99954L11.7622 1.39097C12.0805 1.07276 12.0805 0.556796 11.7622 0.238593C11.444 -0.0795305 10.9282 -0.0795312 10.6101 0.238592L6.00046 4.84737L1.39086 0.238593C1.07268 -0.0795303 0.556874 -0.0795306 0.238694 0.238593C-0.0795645 0.556795 -0.0795649 1.07276 0.238694 1.39097L4.84808 5.99954L0.238694 10.6081Z",
  fill: "#0086CD"
}));

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 20 20",
  id: "arrow-down-v2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
}));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 10 16",
  fill: "none",
  id: "arrow-right-v2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.72727 0.727274C2.32561 0.325612 1.67439 0.325612 1.27273 0.727274C0.871067 1.12893 0.871066 1.78016 1.27273 2.18182L7.09091 8L1.27273 13.8182C0.871067 14.2198 0.871067 14.8711 1.27273 15.2727C1.67439 15.6744 2.32561 15.6744 2.72727 15.2727L10 8L2.72727 0.727274Z",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 12 10",
  fill: "none",
  id: "check"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.4131 0.494873L12 2.08185L4.57656 9.50529L0 4.92884L1.58693 3.34186L4.57656 6.33139L10.4131 0.494873Z",
  fill: "#0086CD"
}));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 14 14",
  fill: "none",
  id: "close"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.278417 12.3773C-0.0928052 12.7485 -0.0928049 13.3504 0.278418 13.7216C0.64964 14.0928 1.25151 14.0928 1.62273 13.7216L7 8.34432L12.3773 13.7216C12.7485 14.0928 13.3504 14.0928 13.7216 13.7216C14.0928 13.3504 14.0928 12.7485 13.7216 12.3773L8.34432 7L13.7216 1.62273C14.0928 1.25151 14.0928 0.64964 13.7216 0.278418C13.3504 -0.0928049 12.7485 -0.0928064 12.3773 0.278416L7 5.65568L1.62273 0.278417C1.25151 -0.0928053 0.64964 -0.0928051 0.278418 0.278417C-0.0928049 0.64964 -0.0928064 1.25151 0.278416 1.62273L5.65568 7L0.278417 12.3773Z",
  fill: "#262626"
}));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 14",
  fill: "none",
  id: "de"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 9.33325H18V13.9999H0V9.33325Z",
  fill: "#FFCE00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0H18V4.66667H0V0Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 4.66675H18V9.33342H0V4.66675Z",
  fill: "#D00"
}));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "edit"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.70555 3.33642L12.5535 6.19826L5.3446 13.4424L2.4983 10.5806L9.70555 3.33642ZM14.7145 2.64621L13.4444 1.36993C12.9536 0.87669 12.1566 0.87669 11.6641 1.36993L10.4475 2.59248L13.2954 5.45434L14.7145 4.0283C15.0952 3.64572 15.0952 3.02877 14.7145 2.64621ZM1.00793 14.6031C0.956097 14.8375 1.16669 15.0476 1.39997 14.9906L4.5735 14.2173L1.7272 11.3555L1.00793 14.6031Z",
  fill: "#0086CD"
}));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 12",
  fill: "none",
  id: "email"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5713 12C14.931 12 15.2426 11.8867 15.5076 11.6629L10.9745 7.3357C10.8657 7.41004 10.7603 7.48233 10.6607 7.55107C10.3215 7.78964 10.0461 7.97581 9.83473 8.10921C9.62334 8.24292 9.34208 8.3792 8.991 8.51834C8.63968 8.65765 8.31238 8.72708 8.00876 8.72708H7.99987H7.99098C7.68733 8.72708 7.36003 8.65768 7.00874 8.51834C6.65745 8.3792 6.3762 8.24292 6.16501 8.10921C5.95362 7.97581 5.67844 7.78967 5.33903 7.55107C5.24445 7.48488 5.13955 7.41226 5.02614 7.33453L0.492188 11.6629C0.757086 11.8867 1.06893 12 1.42856 12H14.5713Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.901888 4.61089C0.562681 4.39503 0.261878 4.1478 0 3.86932V10.4527L3.99544 6.63895C3.19613 6.10629 2.16625 5.43104 0.901888 4.61089Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1069 4.61089C13.8907 5.39661 12.8571 6.07301 12.0059 6.64047L15.9997 10.4529V3.86932C15.7437 4.1422 15.4461 4.38926 15.1069 4.61089Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5712 0H1.42849C0.969979 0 0.617468 0.147792 0.370521 0.443072C0.123372 0.738491 0 1.10794 0 1.55102C0 1.90891 0.163721 2.29669 0.491017 2.71447C0.818313 3.13209 1.16658 3.46012 1.53565 3.69872C1.73798 3.83517 2.34813 4.24006 3.36609 4.91325C3.91562 5.27674 4.3935 5.59357 4.80417 5.86697C5.15421 6.09978 5.45609 6.30139 5.70533 6.46871C5.73394 6.48787 5.77894 6.51859 5.83867 6.55935C5.90301 6.60347 5.98444 6.65945 6.08489 6.72869C6.27833 6.86223 6.43902 6.97017 6.56702 7.05264C6.69483 7.13513 6.84969 7.22727 7.03137 7.32959C7.21289 7.43177 7.38411 7.5086 7.54481 7.55971C7.70554 7.61078 7.85433 7.6364 7.99121 7.6364H8.00009H8.00898C8.14583 7.6364 8.29465 7.61078 8.45541 7.55971C8.61608 7.5086 8.78715 7.43194 8.96882 7.32959C9.15032 7.22727 9.30498 7.13494 9.4332 7.05264C9.56119 6.97017 9.72189 6.86226 9.91536 6.72869C10.0156 6.65945 10.097 6.60344 10.1614 6.55949C10.2211 6.51856 10.2661 6.48803 10.2949 6.46871C10.4891 6.33974 10.7916 6.13896 11.1984 5.86933C11.9387 5.3784 13.0288 4.65582 14.4735 3.69872C14.908 3.40904 15.271 3.05947 15.5627 2.6505C15.8539 2.24154 15.9999 1.81255 15.9999 1.36368C15.9999 0.988657 15.8584 0.667756 15.5759 0.400481C15.293 0.13354 14.9581 0 14.5712 0Z",
  fill: "#fff"
}));

var _ref9 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 14",
  fill: "none",
  id: "en"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H18V1.07734H0V0ZM0 2.15469H18V3.23203H0V2.15469ZM0 4.30664H18V5.38672H0V4.30664ZM0 6.46133H18V7.53867H0V6.46133ZM0 8.61602H18V9.69336H0V8.61602ZM0 10.768H18V11.8453H0V10.768ZM0 12.9227H18V14H0V12.9227Z",
  fill: "#BD3D44"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.07739H18V2.15474H0V1.07739ZM0 3.23208H18V4.30669H0V3.23208ZM0 5.38403H18V6.46138H0V5.38403ZM0 7.53872H18V8.61607H0V7.53872ZM0 9.69341H18V10.7708H0V9.69341ZM0 11.8454H18V12.9227H0V11.8454Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H7.19958V7.53868H0V0Z",
  fill: "#192F5D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.599818 0.323242L0.666431 0.621289H0.87737L0.707138 0.804492L0.7719 1.10527L0.599818 0.919336L0.429586 1.10254L0.494348 0.804492L0.322266 0.621289H0.536906L0.599818 0.323242ZM1.80069 0.323242L1.86546 0.621289H2.07825L1.90616 0.804492L1.97093 1.10527L1.80069 0.919336L1.62861 1.10254L1.69337 0.804492L1.52314 0.621289H1.73408L1.80069 0.323242ZM2.99972 0.323242L3.06633 0.621289H3.27542L3.10519 0.804492L3.16995 1.10527L2.99787 0.919336L2.82764 1.10254L2.8924 0.804492L2.72032 0.621289H2.93311L2.99972 0.323242ZM4.2006 0.323242L4.26536 0.621289H4.47815L4.30607 0.804492L4.37268 1.10527L4.2006 0.919336L4.02851 1.10254L4.09513 0.804492L3.92304 0.621289H4.13398L4.2006 0.323242ZM5.39962 0.323242L5.46624 0.621289H5.67717L5.50694 0.804492L5.57171 1.10527L5.39962 0.919336L5.22939 1.10254L5.29415 0.804492L5.12392 0.621289H5.33486L5.39962 0.323242ZM6.6005 0.323242L6.66526 0.621289H6.87805L6.70597 0.804492L6.77258 1.10527L6.6005 0.919336L6.42842 1.10254L6.49503 0.804492L6.32295 0.621289H6.53574L6.6005 0.323242ZM1.20118 1.07793L1.26594 1.37598H1.47873L1.30665 1.55918L1.36956 1.85723L1.20303 1.67402L1.03095 1.85723L1.09201 1.55918L0.925479 1.37598H1.13642L1.20118 1.07793ZM2.40021 1.07793L2.46682 1.37598H2.67776L2.50568 1.55918L2.57229 1.85723L2.40021 1.67402L2.22812 1.85723L2.29474 1.55918L2.12265 1.37598H2.33544L2.40021 1.07793ZM3.60108 1.07793L3.66585 1.37598H3.87864L3.70655 1.55918L3.77132 1.85723L3.60108 1.67402L3.429 1.85723L3.49376 1.55918L3.32353 1.37598H3.53447L3.60108 1.07793ZM4.80011 1.07793L4.86672 1.37598H5.07766L4.90558 1.55918L4.97219 1.85723L4.80011 1.67402L4.62988 1.85723L4.69464 1.55918L4.52256 1.37598H4.7372L4.80011 1.07793ZM6.00099 1.07793L6.06575 1.37598H6.27854L6.10646 1.55918L6.17122 1.85723L6.00099 1.67402L5.8289 1.85723L5.89367 1.55918L5.72343 1.37598H5.93437L6.00099 1.07793ZM0.599818 1.82988L0.666431 2.1334H0.87737L0.707138 2.3166L0.7719 2.61465L0.599818 2.42871L0.429586 2.61465L0.494348 2.31387L0.322266 2.13066H0.536906L0.599818 1.82988ZM1.80069 1.82988L1.86546 2.13066H2.07825L1.90616 2.31387L1.97093 2.61191L1.80069 2.42598L1.62861 2.61191L1.69337 2.31113L1.52314 2.12793H1.73408L1.80069 1.82988ZM2.99972 1.82988L3.06633 2.13066H3.27542L3.10519 2.31387L3.16995 2.61191L2.99787 2.42598L2.82764 2.61191L2.8924 2.31113L2.72032 2.12793H2.93311L2.99972 1.82988ZM4.2006 1.82988L4.26536 2.13066H4.47815L4.30607 2.31387L4.37268 2.61191L4.2006 2.42598L4.02851 2.61191L4.09513 2.31113L3.92304 2.12793H4.13398L4.2006 1.82988ZM5.39962 1.82988L5.46624 2.13066H5.67717L5.50694 2.31387L5.57171 2.61191L5.39962 2.42598L5.22939 2.61191L5.29415 2.31113L5.12392 2.12793H5.33486L5.39962 1.82988ZM6.6005 1.82988L6.66526 2.13066H6.87805L6.70597 2.31387L6.77258 2.61191L6.6005 2.42598L6.42842 2.61191L6.49503 2.31113L6.32295 2.12793H6.53574L6.6005 1.82988ZM1.20118 2.58457L1.26594 2.88262H1.47873L1.30665 3.06582L1.37141 3.3666L1.20118 3.18066L1.0291 3.36387L1.09386 3.06582L0.923629 2.88262H1.13457L1.20118 2.58457ZM2.40021 2.58457L2.46682 2.88262H2.67776L2.50568 3.06582L2.57229 3.3666L2.40021 3.18066L2.22812 3.36387L2.29474 3.06582L2.12265 2.88262H2.33544L2.40021 2.58457ZM3.60108 2.58457L3.66585 2.88262H3.87864L3.70655 3.06582L3.77132 3.3666L3.60108 3.18066L3.429 3.36387L3.49376 3.06582L3.32353 2.88262H3.53447L3.60108 2.58457ZM4.80011 2.58457L4.86672 2.88262H5.07766L4.90743 3.06582L4.97219 3.3666L4.80011 3.18066L4.62988 3.36387L4.69464 3.06582L4.52256 2.88262H4.7372L4.80011 2.58457ZM6.00099 2.58457L6.06575 2.88262H6.27854L6.10646 3.06582L6.17122 3.3666L6.00099 3.18066L5.8289 3.36387L5.89367 3.06582L5.72343 2.88262H5.93437L6.00099 2.58457ZM0.599818 3.33926L0.666431 3.6373H0.87737L0.707138 3.82051L0.7719 4.12129L0.599818 3.93535L0.429586 4.11855L0.494348 3.82051L0.322266 3.6373H0.536906L0.599818 3.33926ZM1.80069 3.33926L1.86546 3.6373H2.07825L1.90616 3.82051L1.97093 4.11855L1.80069 3.93535L1.62861 4.11855L1.69337 3.82051L1.52314 3.6373H1.73408L1.80069 3.33926ZM2.99972 3.33926L3.06633 3.6373H3.27542L3.10519 3.82051L3.16995 4.12129L2.99787 3.93535L2.82764 4.11855L2.8924 3.82051L2.72032 3.6373H2.93311L2.99972 3.33926ZM4.2006 3.33926L4.26536 3.6373H4.47815L4.30607 3.82051L4.37268 4.12129L4.2006 3.93535L4.02851 4.11855L4.09513 3.82051L3.92304 3.6373H4.13398L4.2006 3.33926ZM5.39962 3.33926L5.46624 3.6373H5.67717L5.50694 3.82051L5.57171 4.12129L5.39962 3.93535L5.22939 4.11855L5.29415 3.82051L5.12392 3.6373H5.33486L5.39962 3.33926ZM6.6005 3.33926L6.66526 3.6373H6.87805L6.70597 3.82051L6.77258 4.12129L6.6005 3.93535L6.42842 4.11855L6.49503 3.82051L6.32295 3.6373H6.53574L6.6005 3.33926ZM1.20118 4.09394L1.26594 4.39199H1.47873L1.30665 4.57519L1.37141 4.87324L1.20118 4.6873L1.0291 4.87324L1.09386 4.57246L0.923629 4.38926H1.13457L1.20118 4.09394ZM2.40021 4.09394L2.46682 4.39199H2.67776L2.50568 4.57519L2.57229 4.87324L2.40021 4.6873L2.22812 4.87324L2.29474 4.57246L2.12265 4.38926H2.33544L2.40021 4.09394ZM3.60108 4.09394L3.66585 4.39199H3.87864L3.70655 4.57519L3.77132 4.87324L3.60108 4.6873L3.429 4.87324L3.49376 4.57246L3.32353 4.38926H3.53447L3.60108 4.09394ZM4.80011 4.09394L4.86672 4.39199H5.07766L4.90743 4.57519L4.97219 4.87324L4.80011 4.6873L4.62988 4.87324L4.69464 4.57246L4.52256 4.38926H4.7372L4.80011 4.09394ZM6.00099 4.09394L6.06575 4.39199H6.27854L6.10646 4.57519L6.17122 4.87324L6.00099 4.6873L5.8289 4.87324L5.89367 4.57246L5.72343 4.38926H5.93437L6.00099 4.09394ZM0.599818 4.8459L0.666431 5.14668H0.87737L0.707138 5.32988L0.7719 5.62519L0.599818 5.44199L0.429586 5.62519L0.494348 5.32715L0.322266 5.14394H0.536906L0.599818 4.8459ZM1.80069 4.8459L1.86546 5.14668H2.07825L1.90616 5.32988L1.97278 5.62519L1.80069 5.44199L1.62861 5.62519L1.69522 5.32715L1.52314 5.14394H1.73408L1.80069 4.8459ZM2.99972 4.8459L3.06633 5.14668H3.27542L3.10519 5.32988L3.16995 5.62519L2.99787 5.44199L2.82764 5.62519L2.8924 5.32715L2.72032 5.14394H2.93311L2.99972 4.8459ZM4.2006 4.8459L4.26536 5.14668H4.47815L4.30607 5.32988L4.37268 5.62519L4.2006 5.44199L4.02851 5.62519L4.09513 5.32715L3.92304 5.14394H4.13398L4.2006 4.8459ZM5.39962 4.8459L5.46624 5.14668H5.67717L5.50694 5.32988L5.57171 5.62519L5.39962 5.44199L5.22939 5.62519L5.29415 5.32715L5.12392 5.14394H5.33486L5.39962 4.8459ZM6.6005 4.8459L6.66526 5.14668H6.87805L6.70597 5.32988L6.77258 5.62519L6.6005 5.44199L6.42842 5.62519L6.49503 5.32715L6.32295 5.14394H6.53574L6.6005 4.8459ZM1.20118 5.60058L1.26594 5.89863H1.47873L1.30665 6.08183L1.37141 6.38262L1.20118 6.19668L1.0291 6.37988L1.09386 6.08183L0.923629 5.89863H1.13457L1.20118 5.60058ZM2.40021 5.60058L2.46682 5.89863H2.67776L2.50568 6.08183L2.57229 6.38262L2.40021 6.19668L2.22812 6.37988L2.29474 6.08183L2.12265 5.89863H2.33544L2.40021 5.60058ZM3.60108 5.60058L3.66585 5.89863H3.87864L3.70655 6.08183L3.77132 6.38262L3.60108 6.19668L3.429 6.37988L3.49376 6.08183L3.32353 5.89863H3.53447L3.60108 5.60058ZM4.80011 5.60058L4.86672 5.89863H5.07766L4.90743 6.08183L4.97219 6.38262L4.80011 6.19668L4.62988 6.37988L4.69464 6.08183L4.52256 5.89863H4.7372L4.80011 5.60058ZM6.00099 5.60058L6.06575 5.89863H6.27854L6.10646 6.08183L6.17122 6.38262L6.00099 6.19668L5.8289 6.37988L5.89367 6.08183L5.72343 5.89863H5.93437L6.00099 5.60058ZM0.599818 6.35527L0.666431 6.65332H0.87737L0.707138 6.83652L0.7719 7.13457L0.599818 6.95137L0.429586 7.13457L0.494348 6.83379L0.322266 6.65058H0.536906L0.599818 6.35527ZM1.80069 6.35527L1.86546 6.65332H2.07825L1.90616 6.83652L1.97278 7.13457L1.80069 6.95137L1.62861 7.13457L1.69522 6.83379L1.52314 6.65058H1.73408L1.80069 6.35527ZM2.99972 6.35527L3.06633 6.65332H3.27542L3.10889 6.83652L3.17365 7.13457L3.00157 6.95137L2.83134 7.13457L2.8961 6.83379L2.72402 6.65058H2.93681L2.99972 6.35527ZM4.2006 6.35527L4.26536 6.65332H4.47815L4.30607 6.83652L4.37268 7.13457L4.2006 6.95137L4.02851 7.13457L4.09513 6.83379L3.92304 6.65058H4.13398L4.2006 6.35527ZM5.39962 6.35527L5.46624 6.65332H5.67717L5.50694 6.83652L5.57171 7.13457L5.39962 6.95137L5.22939 7.13457L5.29415 6.83379L5.12392 6.65058H5.33486L5.39962 6.35527ZM6.6005 6.35527L6.66526 6.65332H6.87805L6.70597 6.83652L6.77258 7.13457L6.6005 6.95137L6.42842 7.13457L6.49503 6.83379L6.32295 6.65058H6.53574L6.6005 6.35527Z",
  fill: "#fff"
}));

var _ref10 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 750 500",
  id: "es"
}, /*#__PURE__*/React.createElement("rect", {
  width: 750,
  height: 500,
  fill: "#c60b1e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 750,
  height: 250,
  y: 125,
  fill: "#ffc400"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 0.39
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.26
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeLinejoin: "round",
  d: "m167.99 222.24s-0.51 0-0.79-0.16-1.13-0.96-1.13-0.96l-0.68-0.49-0.62-0.85s-0.73-1.18-0.4-2.09c0.34-0.91 0.91-1.23 1.42-1.5 0.51-0.26 1.58-0.59 1.58-0.59s0.85-0.37 1.13-0.42c0.28-0.06 1.3-0.32 1.3-0.32s0.28-0.16 0.56-0.27c0.29-0.11 0.68-0.11 0.91-0.16 0.22-0.06 0.79-0.24 1.13-0.26 0.52-0.02 1.36 0.1 1.64 0.1s1.24 0.05 1.64 0.05c0.39 0 1.8-0.11 2.2-0.11 0.39 0 0.68-0.05 1.13 0 0.45 0.06 1.24 0.32 1.47 0.43s1.58 0.59 2.09 0.75 1.75 0.37 2.32 0.64c0.56 0.27 0.91 0.72 1.19 1.1 0.28 0.37 0.34 0.78 0.45 1.05 0.11 0.26 0.11 0.84 0 1.11-0.11 0.26-0.51 0.81-0.51 0.81l-0.62 1.02-0.79 0.64s-0.57 0.54-1.02 0.48c-0.45-0.04-5.03-0.86-7.97-0.86s-7.64 0.86-7.64 0.86h0.01z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.66,
  cy: 215.68,
  rx: 1.38,
  ry: 2.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.68,
  cy: 215.68,
  rx: 0.64,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "none",
  cx: 175.68,
  cy: 213.04,
  rx: 0.93,
  ry: 0.87
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.3,
  d: "m176.96 212.74v0.58h-2.53v-0.58h0.94v-1.32h-0.62v-0.57h0.62v-0.57h0.6v0.57h0.62v0.57h-0.62v1.32h0.99"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m175.94,212.2a0.93,0.87 0 1,1 -0.5,0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.68 222.08h-4.81l-0.11-1.18-0.23-1.23-0.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65 0.1-0.32 0.22-0.56 0.47-0.71 1.18-0.7 3.61 0.98 5.44 3.74 0.16 0.25 0.32 0.5 0.46 0.75h3.97c0.14-0.25 0.3-0.5 0.46-0.75 1.82-2.76 4.26-4.44 5.43-3.74 0.26 0.15 0.37 0.39 0.47 0.71-0.41-0.24-1.62 0.9-2.96 2.65l-0.23 1.53-0.23 1.23-0.1 1.18h-4.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m167.55 215.44c0.91-0.53 3.02 1.14 4.73 3.74m11.55-3.74c-0.91-0.53-3.01 1.14-4.73 3.74"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  d: "m168.58 224.25c-0.2-0.57-0.58-1.08-0.58-1.08 1.95-0.57 4.66-0.93 7.67-0.94 3.01 0.01 5.75 0.37 7.69 0.94 0 0-0.22 0.38-0.52 0.91-0.17 0.3-0.39 0.81-0.38 0.81-1.75-0.54-4.02-0.81-6.8-0.82-2.79 0.01-5.46 0.35-6.86 0.86 0.02 0-0.1-0.32-0.23-0.68h0.01"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.67 226.73c2.43-0.01 5.11-0.38 6.1-0.63 0.66-0.2 1.05-0.49 0.98-0.84-0.04-0.16-0.18-0.3-0.37-0.38-1.46-0.47-4.07-0.8-6.71-0.8-2.63 0-5.27 0.33-6.72 0.8-0.19 0.08-0.33 0.22-0.37 0.38-0.07 0.35 0.32 0.64 0.98 0.84 0.99 0.25 3.68 0.62 6.11 0.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m183.48 222.08l-0.59-0.53s-0.57 0.34-1.28 0.24c-0.7-0.11-0.93-0.97-0.93-0.97s-0.79 0.67-1.44 0.62c-0.65-0.06-1.07-0.62-1.07-0.62s-0.71 0.51-1.33 0.46c-0.62-0.06-1.21-0.83-1.21-0.83s-0.63 0.8-1.25 0.86c-0.62 0.05-1.13-0.54-1.13-0.54s-0.28 0.59-1.07 0.72-1.47-0.62-1.47-0.62-0.45 0.73-0.99 0.92c-0.54 0.18-1.24-0.27-1.24-0.27s-0.12 0.27-0.2 0.43-0.31 0.19-0.31 0.19l0.18 0.47c1.93-0.56 4.56-0.91 7.53-0.91s5.67 0.35 7.61 0.92l0.2-0.54h-0.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.69 219.49l0.28 0.05c-0.05 0.12-0.06 0.24-0.06 0.38 0 0.58 0.5 1.05 1.12 1.05 0.49 0 0.91-0.31 1.06-0.73 0.01 0.01 0.11-0.38 0.15-0.38 0.03 0 0.03 0.41 0.05 0.41 0.07 0.53 0.55 0.89 1.1 0.89 0.62 0 1.11-0.47 1.11-1.06 0-0.04 0-0.08-0.01-0.12l0.35-0.35 0.19 0.44c-0.07 0.14-0.1 0.29-0.1 0.46 0 0.56 0.47 1.01 1.06 1.01 0.37 0 0.69-0.18 0.88-0.45l0.23-0.29v0.36c0 0.34 0.14 0.66 0.49 0.71 0 0 0.38 0.03 0.91-0.38 0.52-0.41 0.8-0.75 0.8-0.75l0.03 0.42s-0.51 0.84-0.97 1.1c-0.25 0.15-0.64 0.31-0.95 0.25-0.32-0.05-0.55-0.31-0.67-0.61-0.23 0.14-0.51 0.22-0.8 0.22-0.63 0-1.2-0.35-1.42-0.86-0.29 0.31-0.69 0.5-1.16 0.5-0.51 0-0.97-0.23-1.26-0.58-0.28 0.27-0.67 0.43-1.09 0.43-0.55 0-1.05-0.28-1.33-0.69-0.29 0.41-0.78 0.69-1.34 0.69-0.42 0-0.81-0.16-1.09-0.43-0.29 0.35-0.75 0.58-1.25 0.58-0.48 0-0.88-0.19-1.17-0.5-0.22 0.51-0.79 0.86-1.42 0.86-0.29 0-0.56-0.08-0.79-0.22-0.12 0.3-0.35 0.56-0.68 0.61-0.3 0.06-0.69-0.1-0.94-0.25-0.47-0.26-1.02-1.1-1.02-1.1l0.07-0.42s0.29 0.34 0.81 0.75 0.91 0.38 0.91 0.38c0.34-0.05 0.49-0.37 0.49-0.71v-0.36l0.22 0.29c0.19 0.27 0.51 0.45 0.88 0.45 0.59 0 1.06-0.45 1.06-1.01 0-0.17-0.02-0.32-0.1-0.46l0.19-0.44 0.35 0.35c-0.01 0.04-0.01 0.08-0.01 0.12 0 0.59 0.49 1.06 1.11 1.06 0.55 0 1.03-0.36 1.11-0.89 0.01 0 0.01-0.41 0.04-0.41 0.05 0 0.14 0.39 0.16 0.38 0.14 0.42 0.56 0.73 1.06 0.73 0.61 0 1.11-0.47 1.11-1.05 0-0.14 0-0.26-0.05-0.38l0.29-0.05h0.01z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m175.67 222.23c-3.01 0.01-5.72 0.37-7.67 0.94-0.13 0.04-0.29-0.06-0.33-0.17-0.04-0.13 0.05-0.28 0.18-0.32 1.95-0.6 4.73-0.98 7.82-0.98s5.88 0.38 7.83 0.98c0.13 0.04 0.22 0.19 0.18 0.32-0.04 0.11-0.2 0.21-0.33 0.17-1.95-0.57-4.67-0.93-7.68-0.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m165.43 221c-0.01 0.01-0.38-0.48-0.65-0.73-0.2-0.18-0.68-0.33-0.68-0.33 0-0.08 0.28-0.28 0.58-0.28 0.18 0 0.35 0.07 0.45 0.2l0.04-0.2s0.24 0.05 0.35 0.32c0.12 0.29 0.05 0.72 0.05 0.72s-0.05 0.2-0.14 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m167.32 220.22l-0.11 0.66-1.4 0.15-0.21-0.12 0.04-0.23 1.06-0.87 0.62 0.41"
}), /*#__PURE__*/React.createElement("path", {
  d: "m165.45 220.75c0.12-0.12 0.36-0.09 0.53 0.06 0.18 0.15 0.24 0.38 0.12 0.5-0.12 0.13-0.36 0.1-0.53-0.06-0.18-0.15-0.24-0.38-0.12-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168.02 220.88c-0.06-0.18 0-0.37 0.13-0.42 0.14-0.03 0.3 0.09 0.37 0.27 0.06 0.19 0 0.38-0.14 0.42-0.13 0.04-0.29-0.08-0.36-0.27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168.67 220.04l0.51 0.48 1.22-0.66 0.09-0.21-0.17-0.17-1.4-0.12-0.25 0.68"
}), /*#__PURE__*/React.createElement("path", {
  d: "m170.08 217.76l-0.67 0.64 0.86 1.14 0.23 0.09 0.17-0.18 0.3-1.37-0.89-0.32"
}), /*#__PURE__*/React.createElement("path", {
  d: "m172.36 219.3l-0.26 0.63-1.4-0.13-0.18-0.16 0.1-0.22 1.22-0.64 0.52 0.52"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 170.51,
  cy: 219.65,
  rx: 0.49,
  ry: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "m172.87 219.95c-0.03-0.2 0.07-0.37 0.21-0.39s0.28 0.13 0.3 0.33c0.03 0.19-0.07 0.37-0.21 0.38-0.14 0.02-0.28-0.13-0.3-0.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m173.78 219.24l0.4 0.57 1.34-0.42 0.14-0.18-0.15-0.2-1.33-0.39-0.4 0.62"
}), /*#__PURE__*/React.createElement("path", {
  d: "m175.66 217.15l-0.86 0.52 0.64 1.38 0.22 0.14 0.22-0.14 0.64-1.38-0.86-0.52"
}), /*#__PURE__*/React.createElement("path", {
  d: "m177.55 219.24l-0.39 0.57-1.34-0.42-0.14-0.18 0.14-0.2 1.34-0.39 0.39 0.62"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.67,
  cy: 219.21,
  rx: 0.49,
  ry: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "m178.5 219.95c0.02-0.2-0.08-0.37-0.22-0.39s-0.28 0.13-0.3 0.33c-0.02 0.19 0.07 0.37 0.21 0.38 0.14 0.02 0.28-0.13 0.31-0.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m178.99 219.3l0.26 0.63 1.4-0.13 0.18-0.16-0.1-0.22-1.22-0.64-0.52 0.52"
}), /*#__PURE__*/React.createElement("path", {
  d: "m181.27 217.76l0.67 0.64-0.86 1.14-0.23 0.09-0.17-0.18-0.3-1.37 0.89-0.32"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182.68 220.04l-0.51 0.48-1.22-0.66-0.1-0.21 0.19-0.17 1.4-0.12 0.24 0.68"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.85,
  cy: 219.65,
  rx: 0.49,
  ry: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "m183.34 220.88c0.06-0.18 0-0.37-0.13-0.42-0.14-0.03-0.3 0.09-0.37 0.27-0.06 0.19 0 0.38 0.14 0.42 0.13 0.04 0.29-0.08 0.36-0.27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.73 221c0.01 0.01 0.38-0.48 0.66-0.73 0.19-0.18 0.67-0.33 0.67-0.33 0-0.08-0.28-0.28-0.58-0.28-0.18 0-0.35 0.07-0.45 0.2l-0.04-0.2s-0.24 0.05-0.36 0.32c-0.11 0.29-0.03 0.72-0.03 0.72s0.04 0.2 0.13 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m183.84 220.22l0.11 0.66 1.4 0.15 0.21-0.12-0.05-0.23-1.05-0.87-0.62 0.41"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.74 220.75c-0.11-0.12-0.35-0.09-0.53 0.06s-0.24 0.38-0.12 0.5c0.12 0.13 0.36 0.1 0.54-0.06 0.18-0.15 0.23-0.38 0.11-0.5z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m168.05 224.3l0.31-0.5 0.65 0.13-0.38 0.56-0.58-0.19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m170.85 223.81l-0.69 0.11c-0.18 0.02-0.35-0.09-0.38-0.26-0.02-0.17 0.1-0.32 0.27-0.35l0.7-0.1 0.71-0.11c0.18-0.02 0.34 0.09 0.37 0.25 0.02 0.17-0.1 0.33-0.27 0.35l-0.71 0.11"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#fff",
  cx: 173.19,
  cy: 223.3,
  rx: 0.44,
  ry: 0.41
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m175.7 223.48h-0.96c-0.18 0-0.33-0.14-0.33-0.31s0.14-0.31 0.32-0.31h1.96c0.19 0 0.33 0.14 0.33 0.31s-0.15 0.31-0.33 0.31h-0.99"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#fff",
  cx: 178.16,
  cy: 223.3,
  rx: 0.44,
  ry: 0.41
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m180.5 223.81l0.69 0.11c0.18 0.02 0.35-0.09 0.38-0.26 0.02-0.17-0.09-0.32-0.27-0.35l-0.7-0.1-0.71-0.11c-0.18-0.02-0.35 0.09-0.37 0.25-0.03 0.17 0.09 0.33 0.27 0.35l0.71 0.11"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m183.24 224.33l-0.25-0.53-0.67 0.06 0.32 0.59 0.6-0.12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeLinejoin: "round",
  d: "m175.66 226.16c-2.43 0-4.63-0.22-6.3-0.65 1.67-0.43 3.87-0.69 6.3-0.7 2.44 0 4.65 0.27 6.33 0.7-1.68 0.43-3.89 0.65-6.33 0.65z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.01,
  d: "m176.8 226.08v-1.16m-0.58 1.2l0.01-1.23m-0.43 1.25v-1.26"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.02,
  d: "m175.44 226.15v-1.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.03,
  d: "m175.09 226.15v-1.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.04,
  d: "m174.77 226.15v-1.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.04,
  d: "m174.44 226.15v-1.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.05,
  d: "m174.16 226.15v-1.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.06,
  d: "m173.61 226.08l-0.01-1.15m0.27 1.17v-1.21"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.07,
  d: "m173.1 226.03v-1.06m0.26 1.09l-0.01-1.13"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.08,
  d: "m172.42 225.97v-0.93m0.23 0.94v-0.98m0.23 1.02v-1.02"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.09,
  d: "m172.19 225.96v-0.9"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "m171.97 225.92v-0.85"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.11,
  d: "m171.73 225.89v-0.78"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.12,
  d: "m171.24 225.82l-0.01-0.62m0.26 0.66v-0.7"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.12,
  d: "m170.99 225.77v-0.55"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.13,
  d: "m170.76 225.73v-0.46"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.14,
  d: "m170.51 225.67v-0.36"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.15,
  d: "m170.26 225.64v-0.27"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.18,
  d: "m169.99 225.58v-0.13"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#005bbf"
}, /*#__PURE__*/React.createElement("path", {
  d: "m191.28 330.68c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.32-3.91 0.83-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.54-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.33 3.92-0.86 1.01-0.52 2.4-0.84 3.91-0.84 1.5 0 2.86 0.32 3.86 0.83 1.02 0.54 2.37 0.87 3.91 0.87l0.02-2.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m191.28 333.09c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.83-3.86-0.83-1.51 0-2.9 0.32-3.91 0.84-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.37-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.54 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.84 3.91-0.84c1.5 0 2.86 0.32 3.86 0.84 1.02 0.53 2.37 0.86 3.91 0.86l0.02-2.41"
}), /*#__PURE__*/React.createElement("path", {
  d: "m191.28 335.5c-1.54 0-2.91-0.33-3.93-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.4c1.53 0 2.93-0.34 3.95-0.88 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.37 0.86 3.91 0.86l0.02-2.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m191.26 340.32c-1.54 0-2.89-0.33-3.91-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.31-3.91 0.83s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.53-2.42 0.88-3.95 0.88v-2.4c1.53 0 2.93-0.36 3.95-0.9 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.39 0.86 3.93 0.86l-0.02 2.42"
}), /*#__PURE__*/React.createElement("path", {
  d: "m191.26 342.73c-1.54 0-2.89-0.33-3.91-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v-2.39c1.53 0 2.93-0.37 3.95-0.9 1-0.52 2.34-0.81 3.86-0.81 1.45 0 2.79 0.3 3.79 0.79 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.83 3.91-0.83c1.5 0 2.86 0.31 3.86 0.82 1.02 0.54 2.38 0.87 3.93 0.87l-0.02 2.41z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m166.92 320.78c0.05 0.21 0.13 0.4 0.13 0.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-0.21 0.04-0.41 0.09-0.62-0.13 0.05-0.29 0.06-0.44 0.06h-16.69c-0.13 0-0.29-0.02-0.41-0.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m167.33 319.27h16.69c0.57 0 1.02 0.35 1.02 0.78s-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.36-1.02-0.79s0.46-0.78 1.02-0.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m164.27 329.86h22.87v-5.83h-22.87v5.83z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m167.55 318.32h16.25v-79.63h-16.25v79.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m179.13 238.8v79.46m1.83-79.46v79.46"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  d: "m164.58 232.37h22.29v-5.84h-22.29v5.84z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m166.92 236.26c0.14-0.06 0.24-0.07 0.41-0.07h16.69c0.17 0 0.32 0.03 0.46 0.08-0.58-0.19-0.99-0.71-0.99-1.32s0.45-1.14 1.03-1.33c-0.14 0.04-0.33 0.08-0.49 0.08h-16.7c-0.17 0-0.33-0.01-0.47-0.06l0.09 0.02c0.6 0.18 0.94 0.71 0.94 1.29 0 0.56-0.38 1.13-0.97 1.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m167.33 236.19h16.69c0.57 0 1.02 0.35 1.02 0.78 0 0.44-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.35-1.02-0.79 0-0.43 0.46-0.78 1.02-0.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m167.33 232.37h16.7c0.57 0 1.03 0.3 1.03 0.66 0 0.37-0.46 0.67-1.03 0.67h-16.7c-0.56 0-1.02-0.3-1.02-0.67 0-0.36 0.46-0.66 1.02-0.66z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ad1519"
}, /*#__PURE__*/React.createElement("path", {
  d: "m162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31 0.12 0.61 0.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-0.9-3.56-2.34-4.64z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39 0.02-5.04 0.25-7.79 0.7-9.72 1.63-17.13 5.51-16.54 8.67 0.01 0.06 0.04 0.2 0.05 0.26 0 0-3.64-8.21-3.7-8.52-0.65-3.51 7.56-7.82 18.35-9.62 3.39-0.57 6.69-0.79 9.56-0.76 6.9 0 12.9 0.89 16.52 2.23l0.04 9.82"
}), /*#__PURE__*/React.createElement("path", {
  d: "m167.52 278.47c-4.51-0.32-7.58-1.53-7.94-3.41-0.28-1.5 1.25-3.17 3.97-4.68 1.21 0.14 2.58 0.3 4 0.3l-0.03 7.79"
}), /*#__PURE__*/React.createElement("path", {
  d: "m183.83 272.38c2.82 0.43 4.93 1.13 5.98 1.99l0.1 0.17c0.5 1.03-1.97 3.22-6.11 5.67l0.03-7.83"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m157.42 293.83c-0.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-0.09-0.17c0.46 0.38 1.18 8.24 1.18 8.24 0.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-0.01z"
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.26
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeWidth: 0.27,
  d: "m324.85 220.42s-0.74 0.78-1.28 0.89c-0.53 0.1-1.21-0.49-1.21-0.49s-0.48 0.51-1.08 0.64c-0.59 0.14-1.41-0.66-1.41-0.66s-0.57 0.8-1.07 0.99c-0.51 0.18-1.13-0.24-1.13-0.24s-0.23 0.39-0.65 0.61c-0.18 0.09-0.48-0.05-0.48-0.05l-0.6-0.38-0.68-0.72-0.62-0.24s-0.28-0.91-0.31-1.07c-0.02-0.16-0.08-0.57-0.08-0.57-0.13-0.65 0.87-1.4 2.3-1.72 0.82-0.19 1.54-0.18 2.06-0.02 0.57-0.48 1.78-0.82 3.2-0.82 1.29 0 2.42 0.27 3.04 0.7 0.61-0.43 1.74-0.7 3.03-0.7 1.42 0 2.62 0.34 3.19 0.82 0.53-0.16 1.24-0.17 2.07 0.02 1.42 0.32 2.43 1.07 2.3 1.72 0 0-0.06 0.41-0.08 0.57-0.03 0.16-0.32 1.07-0.32 1.07l-0.62 0.24-0.68 0.72-0.58 0.38s-0.3 0.14-0.48 0.05c-0.43-0.21-0.66-0.61-0.66-0.61s-0.62 0.42-1.13 0.24c-0.51-0.19-1.07-0.99-1.07-0.99s-0.82 0.8-1.42 0.66c-0.59-0.13-1.07-0.64-1.07-0.64s-0.68 0.59-1.21 0.49c-0.54-0.11-1.27-0.89-1.27-0.89z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 324.82,
  cy: 216.2,
  rx: 1.38,
  ry: 1.96
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 324.85,
  cy: 216.2,
  rx: 0.63,
  ry: 1.81
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "none",
  cx: 324.84,
  cy: 213.95,
  rx: 0.93,
  ry: 0.88
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.3,
  d: "m326.13 213.64v0.58h-2.53v-0.58h0.94v-1.3h-0.62v-0.58h0.62v-0.58h0.61v0.58h0.61v0.58h-0.61v1.3h0.98"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m325.11,213.12a0.93,0.88 0 1,1 -0.51,-0.01"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 0.21
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.26,
  strokeLinecap: "round",
  d: "m314.41 219.99c-0.13-0.33-0.22-0.7-0.22-1.08 0-1.59 1.26-2.88 2.83-2.88 0.5 0 0.96 0.13 1.37 0.37"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.26,
  d: "m319.48 217.93c-0.15-0.26-0.29-0.54-0.29-0.84 0-1.15 1.19-2.08 2.64-2.08 0.62 0 1.2 0.17 1.65 0.45"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.26,
  d: "m330.17 217.96c0.15-0.26 0.25-0.57 0.25-0.87 0-1.15-1.18-2.08-2.64-2.08-0.62 0-1.19 0.17-1.64 0.45"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.26,
  strokeLinecap: "round",
  d: "m335.21 219.99c0.13-0.33 0.21-0.7 0.21-1.08 0-1.59-1.26-2.88-2.82-2.88-0.5 0-0.97 0.13-1.38 0.37"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 313.57,
  cy: 218.68,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 313.74,
  cy: 217.1,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 314.76,
  cy: 215.9,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 316.11,
  cy: 215.25,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 317.55,
  cy: 215.31,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#fff",
  cx: 318.43,
  cy: 217.08,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 318.68,
  cy: 215.58,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 319.81,
  cy: 214.64,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 321.23,
  cy: 214.19,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 322.67,
  cy: 214.24,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 326.94,
  cy: 214.24,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 328.39,
  cy: 214.19,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 329.8,
  cy: 214.64,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 330.93,
  cy: 215.58,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#fff",
  cx: 331.18,
  cy: 217.08,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 332.06,
  cy: 215.31,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 333.51,
  cy: 215.25,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 334.86,
  cy: 215.9,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 335.88,
  cy: 217.1,
  rx: 0.45,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 336.05,
  cy: 218.68,
  rx: 0.45,
  ry: 0.43
})), /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#crown_pt1",
  x: 149.17
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#crown_pt2",
  x: 149.17
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pillar_left",
  x: 149.17
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ribbon_left",
  transform: "matrix(-1,0,0,1,500.57,0)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m166.42 264.65c1.99-0.72 3.29-1.58 2.66-3.14-0.41-1-1.43-1.19-2.97-0.63l-2.71 0.99 2.44 6.03c0.27-0.12 0.54-0.24 0.81-0.34 0.28-0.1 0.57-0.18 0.85-0.26l-1.08-2.64v-0.01zm-1.18-2.91l0.69-0.25c0.57-0.21 1.21 0.1 1.5 0.8 0.21 0.53 0.16 1.13-0.5 1.55-0.21 0.13-0.46 0.23-0.7 0.33l-0.99-2.43"
}), /*#__PURE__*/React.createElement("path", {
  d: "m172.78 259.22c-0.29 0.08-0.57 0.16-0.86 0.22-0.29 0.05-0.59 0.09-0.88 0.12l1.41 6.28 4.38-0.88c-0.05-0.12-0.12-0.26-0.14-0.38-0.03-0.14-0.03-0.28-0.04-0.41-0.77 0.22-1.61 0.46-2.61 0.66l-1.26-5.61"
}), /*#__PURE__*/React.createElement("path", {
  d: "m181.56 264.63c0.82-2.28 1.82-4.46 2.81-6.67-0.18 0.03-0.36 0.06-0.54 0.07s-0.37 0.01-0.54 0c-0.53 1.61-1.18 3.21-1.87 4.8-0.82-1.51-1.73-2.99-2.43-4.51-0.34 0.04-0.69 0.09-1.03 0.12-0.34 0.02-0.7 0.01-1.04 0.02 1.26 2.06 2.48 4.11 3.64 6.23 0.16-0.03 0.32-0.06 0.5-0.08 0.16-0.01 0.33 0.01 0.5 0.02"
}), /*#__PURE__*/React.createElement("path", {
  d: "m190.72 259.8c0.15-0.31 0.31-0.6 0.48-0.89-0.24-0.22-0.96-0.55-1.81-0.63-1.79-0.18-2.81 0.61-2.93 1.69-0.26 2.26 3.31 2.07 3.14 3.57-0.07 0.64-0.75 0.9-1.48 0.83-0.81-0.08-1.41-0.53-1.51-1.19l-0.22-0.02c-0.12 0.39-0.29 0.77-0.48 1.15 0.53 0.34 1.21 0.53 1.85 0.59 1.83 0.19 3.22-0.54 3.35-1.74 0.23-2.15-3.37-2.27-3.23-3.54 0.06-0.53 0.47-0.88 1.4-0.79 0.67 0.07 1.08 0.43 1.26 0.95l0.18 0.02"
}), /*#__PURE__*/React.createElement("path", {
  d: "m310.3 264.98c0.62-2.33 1.41-4.58 2.19-6.87-0.17 0.05-0.35 0.09-0.53 0.11-0.17 0.03-0.36 0.04-0.54 0.05-0.37 1.64-0.88 3.29-1.42 4.94-0.96-1.44-2-2.84-2.83-4.3-0.34 0.07-0.68 0.15-1.02 0.2s-0.69 0.07-1.04 0.11c1.45 1.94 2.85 3.89 4.2 5.91 0.16-0.04 0.32-0.1 0.5-0.12 0.16-0.02 0.33-0.02 0.49-0.03"
}), /*#__PURE__*/React.createElement("path", {
  d: "m316.48 258.16c-0.29 0.01-0.59 0.04-0.88 0.03-0.3 0-0.6-0.04-0.89-0.06l-0.12 6.41 4.49 0.08c-0.03-0.13-0.06-0.28-0.06-0.41s0.04-0.27 0.07-0.4c-0.81 0.05-1.68 0.1-2.71 0.08l0.1-5.73"
}), /*#__PURE__*/React.createElement("path", {
  d: "m323.52 259.21c0.72 0.06 1.41 0.19 2.1 0.31-0.01-0.13-0.03-0.27-0.02-0.41 0.01-0.13 0.06-0.26 0.1-0.39l-6.07-0.5c0.01 0.14 0.03 0.27 0.02 0.4-0.01 0.14-0.06 0.27-0.1 0.4 0.62-0.02 1.37-0.02 2.21 0.05l-0.53 5.77c0.29 0 0.59 0 0.88 0.03 0.3 0.02 0.59 0.07 0.88 0.11l0.53-5.77"
}), /*#__PURE__*/React.createElement("path", {
  d: "m326.01 265.53c0.29 0.05 0.59 0.09 0.88 0.15 0.28 0.06 0.57 0.15 0.85 0.23l0.72-2.94 0.08 0.01c0.16 0.41 0.38 0.9 0.49 1.19l0.9 2.22c0.36 0.06 0.71 0.11 1.05 0.18 0.36 0.08 0.7 0.18 1.04 0.28l-0.31-0.67c-0.48-1-0.99-2.01-1.41-3.02 1.12 0.04 1.98-0.36 2.2-1.26 0.15-0.62-0.1-1.11-0.68-1.53-0.44-0.31-1.28-0.47-1.83-0.6l-2.44-0.53-1.54 6.29m3.14-5.42c0.71 0.16 1.59 0.27 1.59 1.07-0.01 0.21-0.03 0.35-0.06 0.48-0.23 0.94-0.94 1.26-2.13 0.91l0.6-2.46"
}), /*#__PURE__*/React.createElement("path", {
  d: "m337.57 267.46c-0.05 0.69-0.18 1.37-0.31 2.1 0.3 0.14 0.61 0.27 0.9 0.44 0.3 0.16 0.57 0.34 0.86 0.52l0.6-7.23c-0.14-0.06-0.27-0.12-0.41-0.19-0.13-0.07-0.25-0.15-0.37-0.24l-6.38 4.05c0.17 0.08 0.35 0.16 0.51 0.25 0.17 0.09 0.31 0.19 0.47 0.28 0.54-0.45 1.1-0.82 1.74-1.3l2.39 1.31v0.01zm-1.81-1.66l2.13-1.37-0.25 2.4-1.88-1.03"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeWidth: 0.26,
  d: "m249.65 182.72c6.64 0 12.56 0.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47 0.33 4.81 0.39 6.85 0.24 2.73-0.06 6.67 0.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-0.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6 0.21-0.79 2.25-32.91-3.86-33.02 3.86-0.79-2.25-2.61-0.21-5.08-4.07-2.15-1.83-4.3-4.92-0.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04 0.15 4.38 0.09 6.85-0.24 3.24-0.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  d: "m225.34 191.42l1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-0.31 0.02-0.61 0.06-0.91 0.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63 0.95 8.84 2.48 0.06-0.67 0.12-1.25 0.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81"
}), /*#__PURE__*/React.createElement("path", {
  d: "m225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "m202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41 0.33-2.75 0.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23 0.23 6.14 0.67-0.42 0.46-0.75 0.97-1.08 1.48-1.59-0.31-3.29-0.48-5.06-0.48-7.27 0-13.36 2.83-15.12 6.65-0.47 0.97-0.73 2.06-0.73 3.2 0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-0.58 1.2-0.91 2.54-0.91 3.95 0 2.33 0.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.04 171.27c1.76 0 3.28 1.16 3.64 2.73 0.23 1.38 0.38 2.95 0.41 4.62 0.01 0.18-0.01 0.35-0.01 0.52 0 0.2 0.04 0.41 0.05 0.61 0.06 3.52 0.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c0.72-1.9 1.22-5 1.29-8.52 0-0.2 0.04-0.41 0.04-0.61 0-0.17-0.01-0.34-0.01-0.52 0.03-1.67 0.18-3.24 0.41-4.62 0.36-1.57 1.94-2.73 3.7-2.73z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.04 172.94c0.91 0 1.68 0.58 1.87 1.39 0.23 1.31 0.37 2.8 0.4 4.38 0 0.16-0.01 0.32-0.01 0.48 0 0.2 0.03 0.39 0.04 0.59 0.05 3.32 0.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c0.67-1.8 1.15-4.73 1.21-8.05 0-0.2 0.04-0.39 0.04-0.59 0-0.16-0.01-0.32-0.01-0.48 0.03-1.58 0.17-3.07 0.4-4.38 0.18-0.81 1.02-1.39 1.93-1.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.7 191.42l-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-0.31-0.02-0.61-0.06-0.91-0.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63 0.95-8.84 2.48-0.06-0.67-0.12-1.25-0.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-0.33-2.75-0.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23 0.23-6.15 0.67 0.43 0.46 0.76 0.97 1.09 1.48 1.58-0.31 3.29-0.48 5.06-0.48 7.27 0 13.35 2.83 15.11 6.65 0.47 0.97 0.73 2.06 0.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34 0.58 1.2 0.91 2.54 0.91 3.95 0 2.33-0.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#005bbf",
  strokeWidth: 0.26,
  cx: 250.05,
  cy: 167.3,
  rx: 4.43,
  ry: 4.2
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.26,
  d: "m248.89 155.54v2.26h-2.42v2.3h2.42v3.15 3.46h-3.05c-0.03 0.21-0.22 0.37-0.22 0.59 0 0.58 0.12 1.14 0.35 1.64 0 0.02 0.02 0.02 0.03 0.03h8.12c0-0.01 0.02-0.01 0.03-0.03 0.22-0.5 0.35-1.06 0.35-1.64 0-0.22-0.19-0.38-0.22-0.59h-2.96v-3.43-3.18h2.42v-2.3h-2.42v-2.26h-2.43z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 250.04,
  cy: 188.94,
  rx: 1.91,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 250.04,
  cy: 185.4,
  rx: 1.91,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 250.04,
  cy: 181.6,
  rx: 1.52,
  ry: 1.44
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 250.04,
  cy: 178.18,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 250.04,
  cy: 175.18,
  rx: 0.88,
  ry: 0.83
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 198.94,
  cy: 198.67,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 197.44,
  cy: 196.02,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 196.44,
  cy: 192.94,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 196.31,
  cy: 189.64,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 197.12,
  cy: 186.4,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 198.81,
  cy: 183.45,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 201.06,
  cy: 181.02,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 203.68,
  cy: 179.01,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 206.8,
  cy: 177.36,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 210.04,
  cy: 176.19,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 213.66,
  cy: 175.54,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 217.1,
  cy: 175.36,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 220.47,
  cy: 175.48,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 224.21,
  cy: 190.32,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 222.34,
  cy: 187.65,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 221.35,
  cy: 184.75,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 221.47,
  cy: 181.57,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 222.16,
  cy: 178.37,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 223.84,
  cy: 175.48,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 226.4,
  cy: 173.47,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 229.39,
  cy: 171.81,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 232.7,
  cy: 170.82,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.13,
  cy: 170.23,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239.5,
  cy: 170.28,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 242.99,
  cy: 170.87,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 246.23,
  cy: 171.99,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 253.8,
  cy: 171.99,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 257.04,
  cy: 170.87,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 260.54,
  cy: 170.28,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 263.9,
  cy: 170.23,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 267.34,
  cy: 170.82,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 270.64,
  cy: 171.81,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 273.64,
  cy: 173.47,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.19,
  cy: 175.48,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 277.88,
  cy: 178.37,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 278.57,
  cy: 181.57,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 278.69,
  cy: 184.75,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 277.69,
  cy: 187.65,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 275.83,
  cy: 190.32,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 279.57,
  cy: 175.48,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 282.94,
  cy: 175.36,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 286.38,
  cy: 175.54,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 290,
  cy: 176.19,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.24,
  cy: 177.36,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 296.36,
  cy: 179.01,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 298.97,
  cy: 181.02,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 301.22,
  cy: 183.45,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 302.91,
  cy: 186.4,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 303.72,
  cy: 189.64,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 303.6,
  cy: 192.94,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 302.6,
  cy: 196.02,
  rx: 1.1,
  ry: 1.04
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 301.1,
  cy: 198.67,
  rx: 1.1,
  ry: 1.04
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  d: "m250.15 226.18c-12.26-0.02-23.25-1.47-31.09-3.83-0.57-0.18-0.87-0.7-0.84-1.25-0.01-0.52 0.29-1 0.84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27 0.02 23.25 1.47 31.09 3.83 0.55 0.17 0.84 0.65 0.83 1.17 0.03 0.55-0.27 1.07-0.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.07 216.09c-12.41 0.03-23.55 1.58-31.39 4 0.65-0.31 0.59-1.12-0.22-3.2-0.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44 0.02 25.6 1.62 34.27 4.18 0 0-1.53-0.11-2.51 2.42-0.81 2.08-0.87 2.89-0.21 3.2-7.84-2.42-19.19-3.97-31.6-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.12 210.3c-13.43 0.02-25.5 1.62-34.16 4.18-0.58 0.17-1.19-0.05-1.38-0.6s0.12-1.18 0.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77 0.03 26.19 1.71 34.9 4.38 0.58 0.17 0.89 0.8 0.7 1.35s-0.8 0.77-1.38 0.6c-8.67-2.56-20.78-4.16-34.22-4.18"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.2 199.78l1.23 0.22c-0.19 0.5-0.24 1.05-0.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21 0.08 0.05 0.47-1.68 0.68-1.66 0.17 0.02 0.15 1.8 0.22 1.77 0.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-0.19-0.01-0.38-0.04-0.57l1.54-1.52 0.83 1.94c-0.33 0.61-0.46 1.3-0.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-0.78 3.9-1.97l0.99-1.25-0.01 1.53c0 1.55 0.66 2.93 2.16 3.18 0 0 1.73 0.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l0.2 1.8s-1.9 2.95-3.97 4.15c-1.14 0.66-2.86 1.35-4.23 1.13-1.44-0.24-2.48-1.4-3.01-2.74-1.03 0.61-2.25 0.97-3.55 0.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56-1.27 1.16-2.98 1.87-4.88 1.87-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-0.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-0.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-0.36-3.55-0.97-0.54 1.34-1.57 2.5-3.02 2.74-1.36 0.22-3.08-0.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l0.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-0.25 2.16-1.63 2.16-3.18l-0.01-1.53 0.99 1.25c0.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-0.73-0.13-1.42-0.46-2.03l0.83-1.94 1.54 1.52c-0.02 0.19-0.04 0.38-0.04 0.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93 0.06 0.03 0.05-1.75 0.22-1.77 0.2-0.02 0.6 1.71 0.67 1.66 0.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-0.58-0.03-1.13-0.24-1.63l1.29-0.22"
}), /*#__PURE__*/React.createElement("path", {
  d: "m208.37 206.32c-0.11-0.37-0.35-0.75-0.72-1.06-0.79-0.68-1.84-0.79-2.36-0.25-0.07 0.07-0.13 0.17-0.17 0.25 0 0-1.11-2.08-2.41-2.78-1.29-0.7-3.49-0.52-3.49-0.52 0-1.6 1.3-2.89 2.99-2.89 0.99 0 1.92 0.41 2.48 1.11l0.23-1.07s1.36 0.27 1.98 1.82-0.06 3.8-0.06 3.8 0.34-0.96 0.85-1.61c0.51-0.64 1.81-1.34 2.49-1.66 0.67-0.31 1.37-0.79 1.37-0.79s0.03 0.18 0.05 0.61c0.03 0.51-0.01 0.83-0.01 0.83 1.24-0.17 2.69 0.04 3.83 0.48-0.49 0.95-1.41 1.84-2.62 2.3 0 0 0.44 0.36 0.83 0.75 0.34 0.34 0.44 0.49 0.44 0.49s-0.85 0.13-1.27 0.19c-0.43 0.05-1.84 0.28-2.69 0.22-0.62-0.04-1.32-0.14-1.74-0.22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m205.29 205.01c0.52-0.54 1.57-0.43 2.36 0.25 0.8 0.67 1.02 1.66 0.51 2.19-0.51 0.54-1.57 0.42-2.36-0.25-0.79-0.68-1.02-1.66-0.51-2.19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m216.39 205.91c-0.28-0.83-0.03-1.65 0.57-1.83 0.6-0.19 1.32 0.33 1.6 1.16s0.03 1.65-0.57 1.84c-0.6 0.18-1.31-0.34-1.6-1.17"
}), /*#__PURE__*/React.createElement("path", {
  d: "m226.12 201.86c-0.33-0.27-0.59-0.64-0.67-1.08s0.01-0.87 0.23-1.23c0 0-0.88-0.44-1.83-0.69-0.72-0.19-1.99-0.2-2.37-0.2-0.38-0.02-1.15-0.03-1.15-0.03s0.07 0.17 0.28 0.55c0.27 0.46 0.5 0.75 0.5 0.75-1.27 0.29-2.35 1.12-3.03 2.09 0.99 0.68 2.3 1.1 3.6 0.97 0 0-0.12 0.34-0.2 0.86-0.06 0.43-0.06 0.61-0.06 0.61s0.71-0.26 1.07-0.39c0.35-0.13 1.54-0.55 2.15-0.96 0.8-0.54 1.48-1.25 1.48-1.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "m225.68 191.65c1.06 0.67 1.98 1.79 2.3 3.03 0 0 0.13-0.25 0.71-0.59 0.59-0.33 1.09-0.32 1.09-0.32s-0.17 0.97-0.25 1.32c-0.09 0.34-0.09 1.38-0.32 2.32-0.23 0.93-0.63 1.68-0.63 1.68-0.42-0.34-0.99-0.51-1.58-0.41-0.58 0.1-1.06 0.44-1.32 0.9 0 0-0.66-0.58-1.21-1.38-0.55-0.81-0.93-1.78-1.13-2.08-0.21-0.3-0.72-1.15-0.72-1.15s0.47-0.18 1.14-0.05c0.67 0.12 0.88 0.32 0.88 0.32-0.14-1.28 0.28-2.62 1.04-3.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "m228.97 201.38c0.22-0.35 0.32-0.79 0.24-1.23s-0.32-0.81-0.66-1.07c0 0 0.67-0.71 1.47-1.26 0.6-0.41 1.8-0.82 2.15-0.95 0.36-0.13 1.07-0.4 1.07-0.4s0 0.18-0.06 0.61c-0.08 0.52-0.2 0.87-0.2 0.87 1.3-0.14 2.62 0.29 3.61 0.98-0.69 0.97-1.77 1.79-3.04 2.08 0 0 0.23 0.28 0.5 0.74 0.21 0.39 0.28 0.56 0.28 0.56s-0.77-0.02-1.15-0.03c-0.38 0-1.65-0.01-2.37-0.2-0.95-0.25-1.84-0.69-1.84-0.69"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#ad1519",
  cx: 227.37,
  cy: 200.45,
  rx: 2.17,
  ry: 2.06
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m237.76 201.77c-0.11-0.87 0.31-1.63 0.93-1.7 0.63-0.07 1.23 0.57 1.34 1.44 0.11 0.86-0.3 1.63-0.93 1.7-0.62 0.07-1.22-0.57-1.34-1.44"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.5 199.83c-0.32-0.36-0.53-0.82-0.53-1.33 0-0.5 0.19-0.97 0.51-1.32 0 0-0.89-0.67-1.89-1.12-0.77-0.35-2.18-0.59-2.6-0.67-0.43-0.08-1.28-0.24-1.28-0.24s0.04 0.2 0.2 0.67c0.2 0.56 0.4 0.93 0.4 0.93-1.47 0.08-2.85 0.81-3.81 1.76 0.96 0.94 2.34 1.66 3.81 1.75 0 0-0.2 0.36-0.4 0.93-0.16 0.46-0.2 0.67-0.2 0.67s0.85-0.16 1.28-0.24c0.42-0.08 1.83-0.32 2.6-0.67 1-0.46 1.91-1.11 1.91-1.11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.11 188.36c1.05 0.95 1.85 2.36 1.95 3.82 0 0 0.19-0.27 0.91-0.53 0.73-0.26 1.28-0.16 1.28-0.16s-0.39 1.05-0.55 1.42c-0.17 0.37-0.39 1.53-0.84 2.53-0.44 1-1.05 1.76-1.05 1.76-0.4-0.45-1-0.75-1.67-0.75-0.68 0-1.27 0.3-1.67 0.75 0 0-0.61-0.76-1.05-1.76-0.45-1-0.67-2.16-0.84-2.53s-0.56-1.42-0.56-1.42 0.56-0.1 1.28 0.16 0.92 0.53 0.92 0.53c0.1-1.46 0.86-2.87 1.89-3.82"
}), /*#__PURE__*/React.createElement("path", {
  d: "m251.76 199.83c0.33-0.36 0.53-0.82 0.53-1.33 0-0.5-0.19-0.97-0.51-1.32 0 0 0.89-0.67 1.9-1.12 0.76-0.35 2.17-0.59 2.6-0.67 0.42-0.08 1.26-0.24 1.26-0.24s-0.02 0.2-0.19 0.67c-0.2 0.56-0.4 0.93-0.4 0.93 1.47 0.08 2.86 0.81 3.81 1.76-0.95 0.94-2.33 1.66-3.81 1.75 0 0 0.2 0.36 0.4 0.93 0.16 0.46 0.19 0.67 0.19 0.67l-1.26-0.24c-0.43-0.08-1.84-0.32-2.6-0.67-1.01-0.46-1.92-1.11-1.92-1.11"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#ad1519",
  cx: 250.14,
  cy: 198.5,
  rx: 2.17,
  ry: 2.06
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m262.58 201.77c0.11-0.87-0.3-1.63-0.93-1.7s-1.23 0.57-1.34 1.44c-0.11 0.86 0.31 1.63 0.93 1.7 0.63 0.07 1.23-0.57 1.34-1.44"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271.38 201.38c-0.22-0.35-0.32-0.79-0.25-1.23 0.09-0.44 0.33-0.81 0.67-1.07 0 0-0.67-0.71-1.47-1.26-0.61-0.41-1.8-0.82-2.16-0.95-0.35-0.13-1.06-0.4-1.06-0.4s-0.01 0.18 0.06 0.61c0.08 0.52 0.19 0.87 0.19 0.87-1.29-0.14-2.61 0.29-3.6 0.98 0.68 0.97 1.77 1.79 3.03 2.08 0 0-0.23 0.28-0.49 0.74-0.22 0.39-0.28 0.56-0.28 0.56l1.14-0.03c0.38 0 1.66-0.01 2.37-0.2 0.95-0.25 1.84-0.69 1.84-0.69"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.67 191.65c-1.06 0.67-1.98 1.79-2.31 3.03 0 0-0.12-0.25-0.71-0.59-0.58-0.33-1.09-0.32-1.09-0.32s0.17 0.97 0.26 1.32c0.09 0.34 0.09 1.38 0.31 2.32 0.23 0.93 0.64 1.68 0.64 1.68 0.42-0.34 0.99-0.51 1.57-0.41 0.59 0.1 1.06 0.44 1.33 0.9 0 0 0.66-0.58 1.21-1.38 0.54-0.81 0.92-1.78 1.12-2.08 0.21-0.3 0.72-1.15 0.72-1.15s-0.47-0.18-1.14-0.05c-0.67 0.12-0.88 0.32-0.88 0.32 0.15-1.28-0.28-2.62-1.03-3.59"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.22 201.86c0.34-0.27 0.6-0.64 0.67-1.08 0.09-0.44 0-0.87-0.22-1.23 0 0 0.88-0.44 1.83-0.69 0.72-0.19 1.99-0.2 2.36-0.2 0.39-0.02 1.15-0.03 1.15-0.03s-0.06 0.17-0.28 0.55c-0.26 0.46-0.49 0.75-0.49 0.75 1.26 0.29 2.34 1.12 3.03 2.09-0.99 0.68-2.31 1.1-3.6 0.97 0 0 0.11 0.34 0.19 0.86 0.06 0.43 0.06 0.61 0.06 0.61s-0.71-0.26-1.06-0.39c-0.36-0.13-1.55-0.55-2.16-0.96-0.79-0.54-1.48-1.25-1.48-1.25"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#ad1519",
  cx: 272.98,
  cy: 200.45,
  rx: 2.17,
  ry: 2.06
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m283.96 205.91c0.28-0.83 0.03-1.65-0.57-1.83-0.6-0.19-1.32 0.33-1.61 1.16-0.28 0.83-0.03 1.65 0.57 1.84 0.6 0.18 1.32-0.34 1.61-1.17"
}), /*#__PURE__*/React.createElement("path", {
  d: "m291.97 206.32c0.11-0.37 0.36-0.75 0.72-1.06 0.79-0.68 1.85-0.79 2.36-0.25 0.07 0.07 0.14 0.17 0.18 0.25 0 0 1.1-2.08 2.4-2.78s3.5-0.52 3.5-0.52c0-1.6-1.31-2.89-3-2.89-0.99 0-1.92 0.41-2.47 1.11l-0.23-1.07s-1.36 0.27-1.98 1.82 0.05 3.8 0.05 3.8-0.33-0.96-0.84-1.61c-0.51-0.64-1.81-1.34-2.49-1.66-0.68-0.31-1.37-0.79-1.37-0.79s-0.03 0.18-0.06 0.61c-0.02 0.51 0.02 0.83 0.02 0.83-1.25-0.17-2.7 0.04-3.83 0.48 0.48 0.95 1.4 1.84 2.61 2.3 0 0-0.43 0.36-0.83 0.75-0.33 0.34-0.43 0.49-0.43 0.49s0.85 0.13 1.27 0.19c0.43 0.05 1.84 0.28 2.68 0.22 0.63-0.04 1.32-0.14 1.74-0.22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m295.05 205.01c-0.51-0.54-1.57-0.43-2.36 0.25-0.79 0.67-1.02 1.66-0.51 2.19 0.51 0.54 1.57 0.42 2.36-0.25 0.79-0.68 1.02-1.66 0.51-2.19"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeLinejoin: "round",
  d: "m250.12 224.57c-11.06-0.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07 0.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.05,
  d: "m258.04 224.28v-6.01m-3.02 6.21l0.04-6.37m-2.24 6.45v-6.49"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.09,
  d: "m250.95 224.64v-6.57"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.14,
  d: "m249.16 224.64v-6.57"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.18,
  d: "m247.48 224.64v-6.57"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.23,
  d: "m245.81 224.64v-6.57"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.28,
  d: "m244.32 224.64v-6.57"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.33,
  d: "m241.48 224.28l-0.04-5.97m1.39 6.05v-6.25"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.37,
  d: "m238.86 224.01v-5.5m1.33 5.66l-0.04-5.86"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.42,
  d: "m235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.46,
  d: "m234.12 223.66v-4.68"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.51,
  d: "m232.97 223.42v-4.36"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.56,
  d: "m231.74 223.31v-4.06"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.6,
  d: "m229.22 222.95l-0.04-3.22m1.33 3.38v-3.62"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.63,
  d: "m227.93 222.68v-2.84"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.68,
  d: "m226.74 222.45v-2.36"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.73,
  d: "m225.45 222.13v-1.85"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.77,
  d: "m224.12 221.98v-1.38"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.91,
  d: "m222.72 221.66v-0.67"
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72 0.02 22.31 1.36 30.06 3.54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m216.72 217.16l1.22-1.59 3.37 0.43-2.69 1.96-1.9-0.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m224.03 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m233.64 215.07l-2.36 0.27c-0.61 0.07-1.17-0.33-1.24-0.9-0.08-0.57 0.35-1.09 0.96-1.15l2.37-0.28 2.42-0.28c0.6-0.07 1.15 0.33 1.22 0.9s-0.36 1.09-0.96 1.16l-2.41 0.28"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m240.54 213.35c0-0.58 0.49-1.04 1.1-1.04 0.6 0 1.1 0.46 1.1 1.04 0 0.57-0.5 1.04-1.1 1.04-0.61 0-1.1-0.47-1.1-1.04"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m250.15 214.16h-3.29c-0.6 0-1.11-0.46-1.11-1.03 0-0.58 0.49-1.04 1.1-1.04h6.64c0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.51 1.03-1.11 1.03h-3.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m257.56 213.35c0-0.58 0.5-1.04 1.1-1.04 0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.49 1.04-1.1 1.04-0.6 0-1.1-0.47-1.1-1.04"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m266.66 215.07l2.36 0.27c0.6 0.07 1.17-0.33 1.24-0.9s-0.36-1.09-0.96-1.15l-2.37-0.28-2.42-0.28c-0.61-0.07-1.15 0.33-1.22 0.9-0.08 0.57 0.36 1.09 0.96 1.16l2.41 0.28"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m274.07 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m283.57 217.16l-1.21-1.59-3.37 0.43 2.69 1.96 1.89-0.8"
}))), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.52
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3h100.42v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd691",
  d: "m252.91 329.55c2.09 0.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-0.06-0.19-0.24-0.5-0.22-0.23-0.64-0.66-0.64-0.66s0.79-0.15 1.25 0.02c0.46 0.18 0.77 0.47 0.77 0.47s0.21-0.43 0.52-0.76c0.3-0.33 0.7-0.53 0.7-0.53s0.46 0.38 0.61 0.64c0.15 0.27 0.25 0.59 0.25 0.59s0.42-0.35 0.79-0.49c0.37-0.15 0.84-0.26 0.84-0.26s-0.13 0.46-0.22 0.69-0.14 0.72-0.14 0.72"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-0.47-4.69-0.09-5.76-0.15 0.03 0.03 1.29 0.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22 0.81 6.19-0.2 6.19-0.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m251.46 340.56s2.54-2.66 5.21-3.02c3.15-0.44 5.22 0.26 6.44 0.58 0.03 0-1.01 0.49-1.56 0.87-0.55 0.37-1.97 1.57-4.14 1.59-2.18 0.03-4.58-0.23-4.97-0.17-0.4 0.06-0.98 0.15-0.98 0.15"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m250.69 337.28c-1-0.93-1.62-2.25-1.62-3.72 0-1.46 0.62-2.78 1.63-3.71 0.99 0.93 1.61 2.25 1.61 3.71 0 1.47-0.62 2.79-1.62 3.72"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "m249.68 342.71s0.61-1.52 0.67-2.83c0.06-1.09-0.15-2.17-0.15-2.17h0.52 0.28s0.39 1.16 0.39 2.17c0 1.02-0.18 2.37-0.18 2.37s-0.55 0.08-0.73 0.17c-0.19 0.09-0.8 0.29-0.8 0.29"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200.03 314.12c0.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-0.07 33.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m211.08 334.23c1.57 0.83 3.72 2.22 6.03 2.77l-0.15-56.96h-5.88v54.19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m222.28 338.25c2.3 0.23 4.01 0.19 5.87 0v-58.21h-5.87v58.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m233.32 337c2.3-0.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-0.15 56.96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m244.81 329.24c2.45-2.18 4.75-7.12 5.59-12.76l0.14-36.44h-5.87l0.14 49.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "m300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#c8b100",
  strokeWidth: 0.26,
  d: "m272.71,306.14c0.05-0.14,0.12-0.27,0.19-0.4l-4.26-4.74-1.67,0.72-3.06-3.39,1-1.46-5.34-5.99c-0.07,0.02-0.2,0.02-0.27,0.04l0.03,4.02,1.75,0.5v4.46l-1.75,0.48-0.03,4.08c0.84,0.26,1.48,0.88,1.74,1.67l3.21,0.01,0.51-1.67h4.72l0.5,1.67zm-6.98-18.5,0,1.61,2.76,0,0-1.61zm-7.3,20.37c0.64,0,1.16-0.49,1.16-1.1s-0.52-1.11-1.16-1.11c-0.65,0-1.17,0.5-1.17,1.11s0.52,1.1,1.17,1.1zm15.99-9.73-1.76-0.48,0-4.46,1.76-0.5-0.01-1.92c-0.85-0.25-1.51-0.87-1.79-1.67h-2.68l-0.51,1.67h-4.71l-0.51-1.67h-3.09c-0.08,0.22-0.17,0.42-0.29,0.61l5.38,5.96,1.67-0.71,3.06,3.4-1,1.45,4.18,4.64c0.09-0.04,0.18-0.08,0.28-0.12zm-7.25-1.39-1.29,1.04,1.77,1.98,1.29-1.05zm8.00432,36.1859c-1.23998-0.065-2.25509-0.9022-2.51432-2.01593-1.67-0.23-3.25-0.66-4.73-1.3l0.84-1.43c1.29,0.55,2.66,0.91,4.08,1.11,0.31-0.66,0.86-1.16,1.58-1.4l0.01-5.62-1.76-0.49v-4.46l1.76-0.48v-7.64c-0.07-0.02-0.13-0.05-0.2-0.09l-3.98,4.42,1,1.44-3.06,3.4-1.67-0.71-3.3,3.67c0.57,0.87,0.55,2-0.11,2.85,0.94,1.05,2.03,1.98,3.24,2.75l-0.84,1.44c-1.42-0.89-2.7-1.99-3.79-3.22-0.87,0.26-1.86,0.11-2.6-0.5-1.15-0.93-1.29-2.56-0.3-3.64l0.14-0.16c-0.69-1.56-1.16-3.24-1.32-5l1.71,0.01c0.14,1.5,0.51,2.93,1.09,4.27,0.49-0.06,1-0.01,1.46,0.16l3.32-3.68-1-1.45,3.06-3.4,1.67,0.72,3.99-4.43c-0.09-0.14-0.15-0.29-0.21-0.46l-2.76,0.01-0.5,1.67h-4.72l-0.51-1.67-3.24-0.01c-0.27,0.76-0.9,1.36-1.69,1.62l-0.01,4.04-1.71-0.01v-4.01c-1.1-0.33-1.91-1.31-1.91-2.47,0-1.15,0.82-2.15,1.92-2.48l0.01-4.05-1.76-0.48v-4.46l1.76-0.5v-4.05c-1.08-0.35-1.84-1.32-1.84-2.45,0-1.43,1.22-2.58,2.73-2.58,1.22,0,2.25,0.74,2.61,1.78h3.09l0.51-1.67h4.71l0.51,1.67h2.68c0.35692-1.0311,1.36258-1.76731,2.55896-1.77984l0.0711,8.36984h-0.85v2.61h0.845l-0.0214,21.59h-0.7836v2.61h0.77946zm-5.914-18.306l-1.29-1.04-1.78,1.98,1.29,1.04zm-9.96-18.44-1.69,0-0.01,2.61,1.7,0zm9.16,11.41,0-1.6-2.85,0,0,1.6zm-10.6,9.69-1.76-0.39-0.25-4.45,1.75-0.58,0,2.56c0,0.99,0.09,1.92,0.26,2.86zm1.46-5.52,1.75,0.41s0.09,2.87,0.05,2.22c-0.04-0.74,0.19,2.24,0.19,2.24l-1.76,0.58c-0.18-0.9-0.24-1.84-0.24-2.79zm10.81,16.93,0.39-1.7c-1.52-0.48-2.93-1.18-4.17-2.09l-1.26,1.11c1.48,1.15,3.19,2.08,5.04,2.68zm-0.85,1.44-1.3,1.22c-1.47-0.54-2.86-1.26-4.12-2.11l0.38-1.77c1.5,1.13,3.21,2.03,5.04,2.66z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chains_half",
  transform: "matrix(-1,0,0,1,550.43,0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  stroke: "none",
  d: "m272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100",
  strokeWidth: 0.46
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  strokeWidth: 0.52,
  d: "m200.12 281.25h50.18v-55.72h-50.18v55.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m217.34 238.41h-0.92v-0.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.93v-0.92h-1.61v0.92h-1.16v-0.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v0.93h-0.93v-0.93h-1.62v0.93h-0.92v-0.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.92v-0.92h-1.85v0.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.05 273.54v-4.86c0-0.92-0.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m222.19 268.91l-2.31-0.23c0-0.92 0.23-2.31 0.93-2.77l2.08 1.62c-0.23 0.23-0.7 0.92-0.7 1.38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m226.12 266.6l1.16-2.08c-0.46-0.23-1.39-0.46-2.08-0.46-0.46 0-1.39 0.23-1.85 0.46l1.15 2.08h1.62z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m228.43 268.91l2.31-0.23c0-0.92-0.23-2.31-0.92-2.77l-2.08 1.62c0.23 0.23 0.69 0.92 0.69 1.38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m221.73 260.83v-5.09c0-1.38-0.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m228.89 260.83v-5.09c0-1.38 0.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.11 248.35l0.23-4.62h-4.39l0.47 4.62h3.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.05 248.35l0.46-4.62h-4.39l0.23 4.62h3.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.51 248.35l-0.46-4.62h4.62l-0.46 4.62h-3.7z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0039f0",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m228.43 273.54v-4.16c0-0.7-0.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m221.27 260.36v-4.39c0-1.15-0.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m229.36 260.36v-4.39c0-1.15 0.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m250.28 281.25h50.32v-55.72h-50.32v55.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  strokeWidth: 0.39,
  d: "m275.93 239.26l0.05-0.62 0.09-0.34s-1.61 0.13-2.46-0.11-1.61-0.59-2.4-1.25c-0.79-0.68-1.1-1.1-1.67-1.18-1.36-0.22-2.4 0.4-2.4 0.4s1.02 0.37 1.78 1.31 1.59 1.41 1.95 1.53c0.59 0.18 2.66 0.05 3.22 0.07 0.57 0.03 1.84 0.19 1.84 0.19z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 0.39
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ed72aa",
  d: "m283.46 237s0.01 0.72 0.08 1.4c0.06 0.67-0.22 1.24-0.11 1.61s0.16 0.66 0.3 0.93c0.14 0.26 0.21 0.94 0.21 0.94s-0.38-0.28-0.74-0.54c-0.35-0.27-0.6-0.44-0.6-0.44s0.07 0.72 0.1 1.03c0.04 0.31 0.22 0.89 0.51 1.24 0.29 0.33 0.87 0.89 1.05 1.33 0.18 0.45 0.14 1.44 0.14 1.44s-0.46-0.75-0.87-0.89c-0.39-0.14-1.26-0.62-1.26-0.62s0.79 0.79 0.79 1.55c0 0.75-0.32 1.6-0.32 1.6s-0.36-0.68-0.83-1.12c-0.47-0.45-1.13-0.9-1.13-0.9s0.52 1.17 0.52 1.95c0 0.79-0.15 2.47-0.15 2.47s-0.39-0.64-0.79-0.96c-0.4-0.31-0.87-0.58-1.02-0.78-0.14-0.21 0.48 0.64 0.54 1.16 0.07 0.51 0.32 2.35 1.92 4.69 0.94 1.37 2.39 3.77 5.5 2.98 3.11-0.78 1.96-4.97 1.3-6.92-0.65-1.95-0.98-4.11-0.94-4.87 0.04-0.75 0.58-2.97 0.51-3.39-0.07-0.41-0.24-2 0.14-3.28 0.4-1.33 0.73-1.85 0.95-2.4 0.21-0.55 0.39-0.86 0.46-1.34s0.07-1.37 0.07-1.37 0.58 1.06 0.73 1.44c0.14 0.38 0.14 1.5 0.14 1.5s0.11-1.12 0.98-1.67 1.88-1.13 2.13-1.44 0.33-0.51 0.33-0.51-0.08 1.92-0.62 2.67c-0.36 0.49-1.77 2.09-1.77 2.09s0.73-0.28 1.23-0.3c0.51-0.04 0.87 0 0.87 0s-0.62 0.48-1.41 1.64c-0.8 1.16-0.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08 0.87-0.5 4.34-0.36 4.86 0.15 0.51 2.03 4.76 2.07 5.79 0.03 1.03 0.21 3.33-1.6 4.8-1.16 0.95-3.07 0.96-3.51 1.23-0.43 0.28-1.29 1.13-1.29 2.91 0 1.79 0.64 2.06 1.15 2.51 0.51 0.44 1.16 0.2 1.3 0.55 0.15 0.34 0.22 0.54 0.44 0.75 0.21 0.2 0.36 0.44 0.29 0.82-0.08 0.38-0.91 1.23-1.2 1.85-0.29 0.61-0.87 2.23-0.87 2.47s-0.07 0.99 0.18 1.37c0 0 0.91 1.06 0.29 1.26-0.4 0.14-0.78-0.25-0.97-0.2-0.54 0.14-0.83 0.47-0.98 0.45-0.36-0.07-0.36-0.25-0.4-0.76-0.03-0.51-0.01-0.72-0.17-0.72-0.22 0-0.33 0.18-0.37 0.45s-0.04 0.89-0.29 0.89-0.61-0.45-0.83-0.55-0.83-0.2-0.87-0.48c-0.03-0.27 0.36-0.85 0.76-0.96 0.4-0.1 0.76-0.3 0.51-0.51-0.26-0.2-0.51-0.2-0.76 0-0.25 0.21-0.79 0.04-0.76-0.27 0.04-0.31 0.11-0.69 0.07-0.86-0.03-0.17-0.47-0.51 0.1-0.82 0.59-0.31 0.84 0.27 1.42 0.17s0.86-0.31 1.08-0.65 0.18-1.06-0.22-1.5c-0.39-0.45-0.79-0.52-0.94-0.8-0.14-0.27-0.36-0.92-0.36-0.92s0.11 1.2 0.04 1.37-0.04 0.89-0.04 0.89-0.39-0.45-0.72-0.79c-0.32-0.34-0.65-1.37-0.65-1.37s-0.03 0.96-0.03 1.34c0 0.37 0.43 0.72 0.29 0.86-0.15 0.13-0.83-0.72-1.02-0.86-0.18-0.14-0.76-0.58-1.01-1.06s-0.44-1.16-0.51-1.41c-0.07-0.24-0.19-1.31-0.07-1.58 0.18-0.4 0.47-1.13 0.47-1.13h-1.41c-0.76 0-1.3-0.23-1.59 0.28s-0.15 1.54 0.21 2.88c0.37 1.33 0.58 1.98 0.48 2.22-0.11 0.24-0.58 0.79-0.76 0.89-0.19 0.11-0.69 0.07-0.91-0.03-0.21-0.1-0.57-0.27-1.26-0.27s-1.12 0.03-1.37-0.03c-0.26-0.07-0.88-0.38-1.17-0.31s-0.79 0.32-0.65 0.72c0.22 0.61-0.21 0.75-0.51 0.72-0.29-0.04-0.53-0.14-0.9-0.24-0.36-0.11-0.9 0-0.83-0.42 0.07-0.41 0.22-0.44 0.4-0.74 0.18-0.32 0.25-0.52 0.04-0.54-0.25-0.02-0.51-0.05-0.7 0.11-0.2 0.16-0.51 0.51-0.76 0.38-0.26-0.14-0.46-0.43-0.46-1.08 0-0.64-0.68-1.2-0.05-1.17 0.62 0.03 1.41 0.48 1.55 0.13s0.06-0.51-0.28-0.78-0.76-0.43-0.31-0.77c0.45-0.35 0.56-0.35 0.74-0.54 0.17-0.18 0.41-0.79 0.73-0.64 0.62 0.3 0.02 0.73 0.65 1.42 0.62 0.69 1.01 0.94 2.06 0.83 1.04-0.11 1.33-0.24 1.33-0.54 0-0.29-0.09-0.82-0.12-1.04-0.02-0.21 0.15-0.99 0.15-0.99s-0.48 0.3-0.63 0.59c-0.13 0.29-0.42 0.8-0.42 0.8s-0.11-0.6-0.08-1.09c0.02-0.29 0.12-0.79 0.11-0.89-0.03-0.27-0.23-0.94-0.23-0.94s-0.16 0.73-0.28 0.94c-0.11 0.21-0.16 1.07-0.16 1.07s-0.67-0.58-0.48-1.55c0.13-0.75-0.12-1.74 0.11-2.06 0.22-0.33 0.75-1.64 2.06-1.69 1.3-0.05 2.31 0.05 2.77 0.03 0.45-0.03 2.06-0.33 2.06-0.33s-2.97-1.52-3.64-1.98c-0.68-0.45-1.73-1.63-2.07-2.16-0.34-0.54-0.65-1.58-0.65-1.58s-0.53 0.02-1.02 0.29c-0.48 0.27-0.96 0.67-1.24 0.99s-0.73 1.05-0.73 1.05 0.08-0.94 0.08-1.23-0.06-0.86-0.06-0.86-0.33 1.28-1.01 1.76c-0.68 0.49-1.47 1.15-1.47 1.15s0.08-0.71 0.08-0.88c0-0.16 0.17-0.99 0.17-0.99s-0.48 0.72-1.21 0.86c-0.74 0.13-1.81 0.11-1.9 0.56-0.08 0.45 0.2 1.07 0.03 1.39s-0.54 0.54-0.54 0.54-0.42-0.35-0.79-0.38c-0.36-0.03-0.71 0.16-0.71 0.16s-0.31-0.4-0.19-0.67c0.11-0.26 0.67-0.66 0.54-0.83-0.15-0.16-0.6 0.06-0.88 0.19-0.28 0.14-0.88 0.27-0.82-0.19 0.05-0.45 0.2-0.72 0.05-1.04-0.14-0.32-0.05-0.53 0.18-0.61 0.22-0.08 1.12 0.02 1.21-0.19 0.08-0.21-0.22-0.48-0.82-0.61-0.59-0.14-0.88-0.49-0.57-0.78 0.32-0.3 0.4-0.38 0.54-0.64 0.14-0.27 0.2-0.76 0.74-0.51 0.53 0.24 0.42 0.83 0.99 1.01 0.56 0.19 1.89-0.08 2.17-0.24s1.19-0.83 1.5-0.99c0.31-0.15 1.61-1.12 1.61-1.12s-0.76-0.53-1.05-0.8c-0.28-0.27-0.78-0.91-1.04-1.05-0.25-0.13-1.5-0.61-1.92-0.64-0.42-0.02-1.72-0.48-1.72-0.48s0.59-0.19 0.79-0.35c0.19-0.16 0.64-0.56 0.87-0.53 0.22 0.02 0.28 0.02 0.28 0.02s-1.21-0.05-1.47-0.13c-0.25-0.08-0.99-0.54-1.27-0.54s-0.84 0.11-0.84 0.11 0.76-0.48 1.38-0.59c0.62-0.1 1.1-0.08 1.1-0.08s-0.96-0.27-1.19-0.58c-0.22-0.33-0.45-0.8-0.62-1.02-0.17-0.21-0.28-0.56-0.59-0.59s-0.85 0.38-1.16 0.35-0.54-0.22-0.57-0.67c-0.02-0.46 0-0.3-0.1-0.54-0.12-0.24-0.57-0.8-0.15-0.93 0.43-0.14 1.33 0.08 1.42-0.08 0.08-0.16-0.48-0.65-0.85-0.83-0.37-0.19-0.96-0.51-0.65-0.78 0.31-0.26 0.62-0.37 0.79-0.61s0.37-0.91 0.74-0.7c0.36 0.21 0.87 1.26 1.16 1.18 0.28-0.08 0.3-0.83 0.25-1.15-0.06-0.32 0-0.88 0.28-0.83s0.51 0.43 0.96 0.46c0.45 0.02 1.13-0.11 1.07 0.21-0.05 0.32-0.31 0.71-0.62 1.06-0.3 0.36-0.45 1.05-0.25 1.5 0.2 0.46 0.71 1.19 1.16 1.48s1.3 0.51 1.84 0.85c0.53 0.35 1.78 1.34 2.2 1.45s0.85 0.32 0.85 0.32 0.48-0.21 1.13-0.21 2.14 0.1 2.71-0.14 1.3-0.64 1.08-1.15c-0.23-0.51-1.47-0.96-1.36-1.36s0.57-0.43 1.33-0.46c0.76-0.02 1.8 0.14 2-0.94 0.2-1.06 0.26-1.68-0.81-1.92-1.08-0.24-1.87-0.27-2.07-1.04-0.2-0.78-0.39-0.97-0.17-1.18 0.23-0.21 0.62-0.32 1.41-0.37 0.8-0.06 1.7-0.06 1.96-0.25 0.25-0.18 0.3-0.69 0.61-0.91 0.31-0.21 1.53-0.4 1.53-0.4s1.46 0.71 2.8 1.71c1.21 0.9 2.3 2.23 2.3 2.23"
}), /*#__PURE__*/React.createElement("path", {
  d: "m269 243.39s-0.8 0.23-1.1 0.67c-0.37 0.53-0.34 1.07-0.34 1.07s0.68-0.56 1.56-0.33c0.87 0.24 0.96 0.33 1.33 0.3s1.27-0.35 1.27-0.35-0.74 0.86-0.65 1.45c0.08 0.58 0.19 0.85 0.17 1.15-0.06 0.72-0.6 1.61-0.6 1.61s0.31-0.19 1.05-0.35c0.73-0.16 1.36-0.51 1.75-0.81 0.39-0.29 0.9-1.02 0.9-1.02s-0.16 1 0 1.42c0.17 0.44 0.23 1.67 0.23 1.67s0.47-0.42 0.85-0.62c0.19-0.11 0.7-0.38 0.9-0.7 0.14-0.22 0.32-1.06 0.32-1.06s0.11 0.9 0.39 1.34c0.28 0.42 0.7 1.74 0.7 1.74s0.29-0.86 0.6-1.21 0.68-0.8 0.7-1.07c0.03-0.27-0.08-0.85-0.08-0.85l0.39 0.85m-11.41 0.61s0.48-0.83 0.93-1.1c0.46-0.26 1.08-0.74 1.25-0.8 0.16-0.05 0.9-0.46 0.9-0.46m0.99 5.17s1.09-0.55 1.41-0.75c0.68-0.4 1.16-1.12 1.16-1.12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 0.26,
  d: "m282.57 240.9s-0.34-0.48-0.42-0.65c-0.09-0.15-0.23-0.48-0.23-0.48"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m278.33 257.41s2.04 1.26 1.98 2.31c-0.06 1.04-1.13 2.41-1.13 2.41"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  strokeWidth: 0.26,
  d: "m273.05 236.24s-0.17-0.48-0.2-0.62c-0.03-0.13-0.12-0.29-0.12-0.29s0.88 0 0.85 0.27c-0.02 0.27-0.28 0.27-0.34 0.37-0.05 0.11-0.19 0.27-0.19 0.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  strokeWidth: 0.05,
  d: "m277.06 234.85l-0.06-0.43s0.77 0 1.13 0.26c0.57 0.4 0.93 1.02 0.91 1.05-0.1 0.09-0.54-0.27-0.85-0.37 0 0-0.23 0.05-0.45 0.05-0.23 0-0.34-0.11-0.37-0.21-0.03-0.12 0.03-0.3 0.03-0.3l-0.34-0.05z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  strokeWidth: 0.26
}, /*#__PURE__*/React.createElement("path", {
  d: "m273.08 240.14l0.33-0.53 0.34 0.49-0.67 0.04"
}), /*#__PURE__*/React.createElement("path", {
  d: "m273.89 240.12l0.4-0.53 0.43 0.48-0.83 0.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "m273.53 236.83l0.82 0.29-0.74 0.38-0.08-0.67"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.52 237.1l0.73 0.18-0.59 0.46-0.14-0.64"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#db4446",
  strokeWidth: 0.39
}, /*#__PURE__*/React.createElement("path", {
  d: "m261.88 236.08s0.48 0.34 0.85 0.4c0.37 0.05 0.76 0.05 0.82 0.05 0.05 0 0.17-0.54 0.11-0.91-0.2-1.2-1.3-1.47-1.3-1.47s0.33 0.73 0.17 1.07c-0.23 0.48-0.65 0.86-0.65 0.86z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m259.59 237.12s-0.43-0.77-1.33-0.67c-0.9 0.11-1.5 0.81-1.5 0.81s1-0.03 1.25 0.13c0.37 0.24 0.48 0.86 0.48 0.86s0.54-0.32 0.71-0.54c0.16-0.21 0.39-0.59 0.39-0.59z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m258.49 240.25s-0.77 0.11-1.19 0.59c-0.43 0.49-0.36 1.4-0.36 1.4s0.5-0.54 0.95-0.54c0.46 0 1.16 0.16 1.16 0.16s-0.22-0.56-0.22-0.8-0.34-0.81-0.34-0.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m261.06 250.37s-0.42-0.45-1.16-0.32c-0.74 0.14-1.22 0.97-1.22 0.97s0.63-0.17 1-0.08c0.36 0.08 0.62 0.45 0.62 0.45s0.34-0.29 0.45-0.45 0.31-0.57 0.31-0.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m260.21 253.34s-0.62-0.1-1.16 0.33c-0.53 0.43-0.56 1.25-0.56 1.25s0.51-0.43 0.91-0.37c0.39 0.05 0.87 0.27 0.87 0.27s0.08-0.51 0.11-0.64c0.09-0.38-0.17-0.84-0.17-0.84z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m261.66 256.08s-0.05 0.79 0.33 1.28c0.4 0.51 1.13 0.59 1.13 0.59s-0.24-0.53-0.28-0.8c-0.06-0.4 0.34-0.75 0.34-0.75s-0.37-0.38-0.73-0.38c-0.37 0-0.79 0.06-0.79 0.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m269 263.12s-0.51-0.64-1.21-0.62c-0.71 0.03-1.45 0.69-1.45 0.69s0.88-0.07 1.11 0.22c0.23 0.3 0.45 0.67 0.45 0.67s0.4-0.21 0.57-0.35c0.17-0.13 0.53-0.61 0.53-0.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m266.83 265.93s-0.93-0.14-1.39 0.35c-0.45 0.48-0.42 1.36-0.42 1.36s0.56-0.61 1.07-0.56 1.08 0.32 1.08 0.32-0.09-0.53-0.15-0.78c-0.05-0.24-0.19-0.69-0.19-0.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m268.84 268.9s-0.46 0.64-0.12 1.15 1.05 0.75 1.05 0.75-0.26-0.37-0.14-0.8c0.09-0.34 0.67-0.8 0.67-0.8l-1.46-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.24 270.11s-0.81-0.19-1.27 0.08c-0.45 0.26-0.82 1.39-0.82 1.39s0.74-0.62 1.28-0.54c0.53 0.08 0.93 0.3 0.93 0.3s0.08-0.46 0.02-0.78c-0.03-0.19-0.14-0.45-0.14-0.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.64 273.1s-0.62 0.64-0.4 1.18c0.23 0.54 0.62 1.1 0.62 1.1s-0.02-0.8 0.23-1.02c0.37-0.32 1.05-0.37 1.05-0.37s-0.54-0.48-0.71-0.54c-0.17-0.05-0.79-0.35-0.79-0.35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m284.75 274.04s-0.31 0.78 0.28 1.28c0.59 0.52 1.11 0.57 1.11 0.57s-0.46-0.81-0.32-1.23c0.15-0.45 0.54-0.72 0.54-0.72s-0.74-0.25-0.85-0.22c-0.11 0.02-0.76 0.32-0.76 0.32z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100",
  strokeWidth: 0.26
}, /*#__PURE__*/React.createElement("path", {
  d: "m282.88 232.71l-0.29 0.02c-0.01 0.03-0.14 0.24-0.26 0.35-0.26 0.25-0.65 0.28-0.86 0.07-0.11-0.11-0.16-0.26-0.14-0.41-0.17 0.09-0.35 0.09-0.51-0.01-0.26-0.15-0.32-0.5-0.14-0.79 0.03-0.06 0.06-0.14 0.11-0.18l-0.02-0.32-0.35 0.08-0.1 0.19c-0.22 0.25-0.54 0.31-0.7 0.17-0.08-0.07-0.14-0.26-0.13-0.27 0 0.01-0.09 0.09-0.17 0.11-0.54 0.13-0.75-1.05-0.77-1.35l-0.17 0.25s0.16 0.7 0.08 1.3c-0.08 0.59-0.29 1.19-0.29 1.19 0.74 0.19 1.86 0.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 0.58-0.32 1.18-0.51s1.36-0.2 1.36-0.2l0.22-0.21c-0.32 0.05-1.58 0.1-1.56-0.43 0-0.08 0.07-0.18 0.08-0.18-0.01 0.01-0.21-0.01-0.3-0.06-0.18-0.13-0.18-0.43 0.02-0.69l0.18-0.13 0.01-0.34-0.34 0.05c-0.03 0.04-0.11 0.09-0.15 0.13-0.27 0.23-0.65 0.25-0.86 0.03-0.13-0.12-0.17-0.29-0.11-0.46-0.16 0.04-0.32 0.03-0.45-0.05-0.26-0.15-0.31-0.52-0.11-0.8 0.09-0.14 0.28-0.31 0.31-0.32l-0.07-0.3h-0.01z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  strokeWidth: 0.05
}, /*#__PURE__*/React.createElement("path", {
  d: "m280.63 233.4c0.05-0.07 0.15-0.06 0.23 0s0.1 0.16 0.06 0.21c-0.05 0.06-0.15 0.06-0.24-0.01-0.07-0.05-0.1-0.15-0.05-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.58 234.19l-0.33-0.25c-0.06-0.04-0.07-0.12-0.04-0.16 0.04-0.04 0.12-0.04 0.18 0l0.33 0.26 0.33 0.25c0.05 0.04 0.08 0.12 0.04 0.16s-0.12 0.04-0.18 0l-0.33-0.26"
}), /*#__PURE__*/React.createElement("path", {
  d: "m279.84 233l-0.26-0.15c-0.07-0.04-0.1-0.12-0.07-0.17s0.11-0.06 0.17-0.02l0.26 0.16 0.26 0.15c0.06 0.03 0.09 0.11 0.07 0.16-0.03 0.05-0.11 0.06-0.17 0.02l-0.26-0.15"
}), /*#__PURE__*/React.createElement("path", {
  d: "m278.8 232.29c0.05-0.06 0.16-0.06 0.24 0 0.08 0.07 0.1 0.16 0.05 0.22-0.05 0.05-0.15 0.05-0.23-0.01s-0.1-0.15-0.06-0.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m282.63 234.92c0.05-0.05 0.03-0.14-0.05-0.21-0.08-0.06-0.19-0.06-0.24 0-0.04 0.05-0.02 0.15 0.06 0.21s0.18 0.06 0.23 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m283.2 235.58l0.22 0.21c0.05 0.05 0.13 0.07 0.18 0.03 0.04-0.04 0.04-0.11-0.01-0.16l-0.21-0.21-0.22-0.21c-0.05-0.05-0.14-0.07-0.18-0.03-0.05 0.03-0.04 0.11 0.01 0.16l0.21 0.21"
}), /*#__PURE__*/React.createElement("path", {
  d: "m284.15 236.39c0.05-0.06 0.03-0.15-0.05-0.21-0.08-0.07-0.18-0.07-0.23-0.01s-0.03 0.15 0.05 0.22c0.08 0.05 0.18 0.06 0.23 0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m279.8 230.84l-0.02 0.54 0.92 0.12 0.15-0.07-0.02-0.15-0.53-0.71-0.5 0.27"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.7 231.92l-0.49 0.27-0.54-0.71-0.01-0.15 0.14-0.06 0.93 0.11-0.03 0.54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280.51 231.25c0.08-0.13 0.26-0.17 0.39-0.09 0.14 0.07 0.18 0.24 0.1 0.37s-0.26 0.17-0.39 0.09c-0.14-0.08-0.18-0.24-0.1-0.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m278.36 230.35c-0.02 0.01-0.13-0.46-0.26-0.71-0.08-0.19-0.39-0.43-0.39-0.43 0.03-0.05 0.42-0.19 0.87 0.09 0.38 0.31-0.03 0.87-0.03 0.87s-0.09 0.14-0.19 0.18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m279.39 230.66l-0.42 0.37-0.68-0.6 0.06-0.08 0.03-0.15 0.92-0.07 0.09 0.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "m278.24 230.29c0.05-0.15 0.18-0.23 0.28-0.2 0.11 0.04 0.15 0.18 0.1 0.33s-0.18 0.23-0.29 0.2c-0.11-0.04-0.15-0.18-0.09-0.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m283.67 231.77l-0.59-0.06-0.25 0.85 0.05 0.14 0.15 0.01 0.83-0.41-0.19-0.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "m282.01 232.03l-0.1 0.54 0.9 0.23 0.15-0.04 0.01-0.14-0.43-0.79-0.53 0.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m283.73 233.36l-0.53 0.2-0.42-0.78 0.01-0.15 0.15-0.03 0.89 0.23-0.1 0.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "m282.65 232.54c0.1-0.12 0.28-0.13 0.4-0.04 0.13 0.09 0.15 0.26 0.05 0.38s-0.28 0.13-0.41 0.04c-0.12-0.09-0.14-0.26-0.04-0.38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m285.64 233.61l0.11 0.55-0.87 0.3-0.16-0.04-0.01-0.14 0.36-0.81 0.57 0.14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m285.49 235.2l-0.56 0.13-0.31-0.83 0.04-0.15 0.15-0.02 0.85 0.35-0.17 0.52"
}), /*#__PURE__*/React.createElement("path", {
  d: "m283.97 233.66l-0.18 0.52 0.85 0.34 0.16-0.02 0.03-0.14-0.3-0.83-0.56 0.13"
}), /*#__PURE__*/React.createElement("path", {
  d: "m284.91 234.63c0.12-0.11 0.12-0.28 0.02-0.39-0.11-0.11-0.29-0.11-0.41-0.02-0.11 0.11-0.12 0.28-0.01 0.39 0.1 0.11 0.29 0.12 0.4 0.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m286.29 236.43c0 0.01 0.5 0.03 0.79 0.09 0.2 0.04 0.52 0.27 0.52 0.27 0.06-0.04 0.12-0.42-0.28-0.79-0.39-0.28-0.88 0.22-0.88 0.22s-0.12 0.12-0.15 0.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m285.75 235.54l-0.29 0.46 0.76 0.51 0.09-0.08 0.13-0.04-0.12-0.88-0.57 0.03"
}), /*#__PURE__*/React.createElement("path", {
  d: "m286.37 236.53c0.14-0.07 0.21-0.22 0.15-0.31s-0.22-0.1-0.36-0.02-0.2 0.22-0.14 0.31c0.05 0.09 0.21 0.1 0.35 0.02z"
}))), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.61
}, /*#__PURE__*/React.createElement("ellipse", {
  fill: "#ad1519",
  cx: 250.43,
  cy: 281.01,
  rx: 16.26,
  ry: 18.3
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#005bbf",
  cx: 250.44,
  cy: 280.97,
  rx: 11.44,
  ry: 13.42
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c8b100",
  strokeWidth: 0.34
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39 0.57 2.54 0.57 2.54-0.21-0.55-0.76-0.94-1.41-0.94-0.83 0-1.5 0.63-1.5 1.42 0 0.22 0.14 0.58 0.24 0.77l0.49 0.99c0.16-0.37 0.54-0.57 0.98-0.57 0.59 0 1.08 0.45 1.08 1.01 0 0.09-0.01 0.17-0.04 0.25l-1.22 0.01v1.03h1.09l-0.81 1.61 1.07-0.42 0.81 0.91 0.84-0.91 1.07 0.42-0.8-1.61h1.08v-1.03l-1.22-0.01c-0.02-0.08-0.02-0.16-0.02-0.25 0-0.56 0.47-1.01 1.06-1.01 0.44 0 0.82 0.2 0.98 0.57l0.49-0.99c0.1-0.19 0.24-0.55 0.24-0.77 0-0.79-0.67-1.42-1.49-1.42-0.66 0-1.21 0.39-1.41 0.94 0 0 0.57-1.15 0.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m242.87 281.11h4.36v-1.03h-4.36v1.03z"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fdl",
  x: 10.63
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fdl",
  x: 5.31,
  y: 9.14
})))));

var _ref11 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 10 18",
  fill: "none",
  id: "facebook"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.4908 18V9.7894H9.43919L9.8806 6.58953H6.4908V4.54655C6.4908 3.62011 6.76599 2.9888 8.18727 2.9888L10 2.988V0.126071C9.68641 0.087145 8.61041 -4.35222e-07 7.35858 -4.35222e-07C4.74505 -4.35222e-07 2.95586 1.49118 2.95586 4.22974V6.58953H0V9.7894H2.95586V18H6.4908Z",
  fill: "#fff"
}));

var _ref12 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 20 20",
  fill: "none",
  id: "facebook-v2"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6471 18.5913C19.6471 19.1758 19.1752 19.6553 18.5835 19.6553H1.40742C0.823151 19.6553 0.34375 19.1832 0.34375 18.5913V1.4088C0.34375 0.824307 0.823151 0.344727 1.40742 0.344727H18.5835C19.1677 0.344727 19.6471 0.816813 19.6471 1.4088V18.5913ZM13.6622 12.1768V19.6553H10.6585V12.1768H8.1416V9.26189H10.6585V7.11127C10.6585 4.61596 12.1791 3.25964 14.4038 3.25964C15.4674 3.25964 16.3813 3.33458 16.651 3.37205V5.98726H15.1079C13.8944 5.98726 13.6622 6.55676 13.6622 7.40352V9.26189H16.5461L16.1716 12.1768H13.6622Z",
  fill: "#fff"
}));

var _ref13 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 14",
  fill: "none",
  id: "fr"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H18V14H0V0Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H5.99906V14H0V0Z",
  fill: "#00267F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0H17.9991V14H12V0Z",
  fill: "#F31830"
}));

var _ref14 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 14 12",
  fill: "none",
  id: "heart"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2812 0C9.52156 0 8.82506 0.233734 8.21114 0.694726C7.62256 1.13668 7.2307 1.69959 7 2.10892C6.7693 1.69957 6.37744 1.13668 5.78886 0.694726C5.17494 0.233734 4.47844 0 3.71875 0C1.59873 0 0 1.68364 0 3.9163C0 6.32835 1.99454 7.97865 5.014 10.477C5.52675 10.9012 6.10794 11.3821 6.71202 11.895C6.79164 11.9627 6.89391 12 7 12C7.10609 12 7.20836 11.9627 7.28798 11.8951C7.89212 11.3821 8.47328 10.9012 8.98633 10.4767C12.0055 7.97865 14 6.32835 14 3.9163C14 1.68364 12.4013 0 10.2812 0Z",
  fill: "#0086CD"
}));

var _ref15 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 14 12",
  fill: "none",
  id: "icon_accept"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.03679 11.0365C4.75274 11.0365 4.46839 10.9282 4.2517 10.7113L0.325284 6.7849C-0.108428 6.35118 -0.108428 5.64812 0.325284 5.2144C0.758997 4.78069 1.46206 4.78069 1.89578 5.2144L5.03679 8.35542L12.1042 1.28813C12.5379 0.854545 13.2412 0.854413 13.6746 1.28813C14.1084 1.72184 14.1084 2.42507 13.6746 2.85862L5.82206 10.7113C5.6052 10.928 5.32098 11.0365 5.03679 11.0365Z",
  fill: "#66BB6A"
}));

var _ref16 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "icon_delete"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.23024 1.38258C2.72004 0.872473 1.89294 0.872473 1.38274 1.38258C0.872419 1.89282 0.872419 2.72017 1.38274 3.2304L6.15318 8L1.38274 12.7696C0.872419 13.2798 0.872419 14.1072 1.38274 14.6174C1.89294 15.1275 2.72004 15.1275 3.23024 14.6174L8.001 9.8475L12.7718 14.6174C13.282 15.1275 14.1091 15.1275 14.6193 14.6174C15.1296 14.1072 15.1296 13.2798 14.6193 12.7696L9.84883 8L14.6193 3.2304C15.1296 2.72017 15.1296 1.89282 14.6193 1.38258C14.1091 0.872473 13.282 0.872474 12.7718 1.38258L8.001 6.1525L3.23024 1.38258Z",
  fill: "#FF5D29"
}));

var _ref17 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "icon_help"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 12.6094C8.43147 12.6094 8.78125 12.2596 8.78125 11.8281C8.78125 11.3967 8.43147 11.0469 8 11.0469C7.56853 11.0469 7.21875 11.3967 7.21875 11.8281C7.21875 12.2596 7.56853 12.6094 8 12.6094Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.57863 0 0 3.57803 0 8C0 12.4214 3.57803 16 8 16C12.4214 16 16 12.422 16 8C16 3.57863 12.422 0 8 0ZM8 14.75C4.26947 14.75 1.25 11.731 1.25 8C1.25 4.26947 4.26897 1.25 8 1.25C11.7305 1.25 14.75 4.26897 14.75 8C14.75 11.7305 11.731 14.75 8 14.75Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4.01562C6.6215 4.01562 5.5 5.13713 5.5 6.51562C5.5 6.86081 5.77981 7.14062 6.125 7.14062C6.47019 7.14062 6.75 6.86081 6.75 6.51562C6.75 5.82638 7.31075 5.26562 8 5.26562C8.68925 5.26562 9.25 5.82638 9.25 6.51562C9.25 7.20487 8.68925 7.76562 8 7.76562C7.65481 7.76562 7.375 8.04544 7.375 8.39062V9.95312C7.375 10.2983 7.65481 10.5781 8 10.5781C8.34519 10.5781 8.625 10.2983 8.625 9.95312V8.93653C9.70206 8.65831 10.5 7.67841 10.5 6.51562C10.5 5.13713 9.3785 4.01562 8 4.01562Z",
  fill: "#F9F9F9"
}));

var _ref18 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 32 32",
  fill: "none",
  id: "icon_instagram"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 5,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.45122 6.5245C8.79268 6.78065 8.23577 7.12218 7.67886 7.6792C7.12195 8.23216 6.78049 8.79325 6.52439 9.44785C6.27642 10.0821 6.10976 10.8099 6.06098 11.8752C6.0122 12.9404 6 13.282 6 15.998C6 18.714 6.0122 19.0555 6.06098 20.1208C6.10976 21.186 6.28049 21.9138 6.52439 22.5481C6.78049 23.2067 7.12195 23.7638 7.67886 24.3208C8.23577 24.8778 8.79268 25.2194 9.45122 25.4755C10.0854 25.7235 10.813 25.8902 11.878 25.939C12.9431 25.9878 13.2846 26 16 26C18.7154 26 19.0569 25.9878 20.122 25.939C21.187 25.8902 21.9146 25.7195 22.5488 25.4755C23.2073 25.2194 23.7642 24.8778 24.3211 24.3208C24.878 23.7638 25.2195 23.2067 25.4756 22.5481C25.7236 21.9138 25.8902 21.186 25.939 20.1208C25.9878 19.0555 26 18.714 26 15.998C26 13.282 25.9878 12.9404 25.939 11.8752C25.8902 10.8099 25.7195 10.0821 25.4756 9.44785C25.2195 8.79325 24.878 8.23216 24.3252 7.6792C23.7683 7.12218 23.2114 6.78065 22.5528 6.5245C21.9187 6.27648 21.1911 6.10978 20.126 6.06099C19.061 6.0122 18.7195 6 16.0041 6C13.2886 6 12.9472 6.0122 11.8821 6.06099C10.813 6.10571 10.0854 6.27648 9.45122 6.5245ZM20.0406 7.8581C21.0163 7.90283 21.5447 8.06546 21.8984 8.2037C22.3659 8.38666 22.6992 8.60215 23.0488 8.95182C23.3984 9.30148 23.6138 9.63488 23.7967 10.1025C23.935 10.4562 24.0976 10.9848 24.1423 11.9606C24.1911 13.0136 24.1992 13.3308 24.1992 16.002C24.1992 18.6733 24.187 18.9904 24.1423 20.0435C24.0976 21.0193 23.935 21.5479 23.7967 21.9016C23.6138 22.3692 23.3984 22.7026 23.0488 23.0522C22.6992 23.4019 22.3659 23.6174 21.8984 23.8004C21.5447 23.9386 21.0163 24.1012 20.0406 24.146C18.9878 24.1948 18.6707 24.2029 16 24.2029C13.3293 24.2029 13.0122 24.1907 11.9593 24.146C10.9837 24.1012 10.4553 23.9386 10.1016 23.8004C9.63415 23.6174 9.30081 23.4019 8.95122 23.0522C8.60163 22.7026 8.38618 22.3692 8.20325 21.9016C8.06504 21.5479 7.90244 21.0193 7.85772 20.0435C7.80894 18.9904 7.80081 18.6733 7.80081 16.002C7.80081 13.3308 7.81301 13.0136 7.85772 11.9606C7.90244 10.9848 8.06504 10.4562 8.20325 10.1025C8.38618 9.63488 8.60163 9.30148 8.95122 8.95182C9.30081 8.60215 9.63415 8.38666 10.1016 8.2037C10.4553 8.06546 10.9837 7.90283 11.9593 7.8581C13.0122 7.80931 13.3293 7.80118 16 7.80118C18.6707 7.80118 18.9878 7.80931 20.0406 7.8581Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8672 16.0021C10.8672 18.8401 13.168 21.1373 16.0013 21.1373C18.8347 21.1373 21.1355 18.836 21.1355 16.0021C21.1355 13.1682 18.8387 10.8669 16.0013 10.8669C13.1639 10.8669 10.8672 13.1642 10.8672 16.0021ZM19.3347 16.0021C19.3347 17.844 17.8428 19.3361 16.0013 19.3361C14.1599 19.3361 12.668 17.844 12.668 16.0021C12.668 14.1603 14.1599 12.6681 16.0013 12.6681C17.8428 12.6681 19.3347 14.1603 19.3347 16.0021Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.342 11.8631C22.0044 11.8631 22.5414 11.3261 22.5414 10.6637C22.5414 10.0012 22.0044 9.46423 21.342 9.46423C20.6796 9.46423 20.1426 10.0012 20.1426 10.6637C20.1426 11.3261 20.6796 11.8631 21.342 11.8631Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.582241 29.0703) rotate(-3.0007) scale(46.2644 39.3322)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FED576"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2634,
  stopColor: "#F47133"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6091,
  stopColor: "#BC3081"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4C63D2"
}))));

var _ref19 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 32 32",
  fill: "none",
  id: "icon_linkedin"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 5,
  fill: "#2867B2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.858 9.86658C11.858 10.9015 11.1135 11.7315 9.91673 11.7315H9.89388C8.74286 11.7315 8 10.8998 8 9.86658C8 8.80777 8.76735 8 9.93959 8C11.1135 8 11.8351 8.80606 11.858 9.86658ZM8.20082 23.9983H11.631V13.2053H8.20082V23.9983ZM20.0506 12.9525C18.2302 12.9525 17.4171 13.9977 16.9584 14.7354V14.7696H16.9355C16.9437 14.7593 16.9518 14.7474 16.9584 14.7354V13.207H13.5298C13.5739 14.218 13.5298 24 13.5298 24H16.96V17.9716C16.96 17.6471 16.9812 17.3278 17.0727 17.0955C17.3208 16.4534 17.8857 15.7823 18.831 15.7823C20.0735 15.7823 20.5714 16.7745 20.5714 18.2244V23.9983H24V17.8111C24 14.4929 22.3069 12.9525 20.0506 12.9525Z",
  fill: "#fff"
}));

var _ref20 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 24 18",
  fill: "none",
  id: "icon_messenger"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.8566 17.9998C22.396 17.9998 22.8635 17.8298 23.2609 17.494L16.4614 11.0034C16.2982 11.1149 16.1401 11.2233 15.9908 11.3264C15.4819 11.6843 15.0689 11.9635 14.7518 12.1636C14.4347 12.3642 14.0129 12.5686 13.4862 12.7773C12.9593 12.9863 12.4683 13.0904 12.0129 13.0904H11.9996H11.9862C11.5308 13.0904 11.0398 12.9863 10.5129 12.7773C9.98599 12.5686 9.56412 12.3642 9.24734 12.1636C8.93026 11.9635 8.5175 11.6843 8.0084 11.3264C7.86652 11.2272 7.70918 11.1182 7.53907 11.0016L0.738281 17.494C1.13562 17.8298 1.60337 17.9998 2.14281 17.9998H21.8566Z",
  fill: "#0086CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.35281 6.91623C0.844008 6.59244 0.39281 6.2216 0 5.80389V15.6789L5.99307 9.95826C4.79412 9.15928 3.24932 8.14644 1.35281 6.91623Z",
  fill: "#0086CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.6593 6.91623C20.8351 8.09478 19.2846 9.10937 18.0078 9.96055L23.9985 15.6791V5.80389C23.6144 6.2132 23.1681 6.58379 22.6593 6.91623Z",
  fill: "#0086CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8565 0H2.1427C1.45494 0 0.926187 0.221685 0.555773 0.664598C0.185054 1.10772 0 1.66189 0 2.32649C0 2.86331 0.245577 3.44498 0.736514 4.07164C1.22745 4.69806 1.74985 5.19009 2.30344 5.54799C2.60693 5.75267 3.52213 6.35999 5.04906 7.36976C5.87333 7.91499 6.59015 8.39022 7.20614 8.80032C7.7312 9.14952 8.18401 9.45194 8.55786 9.7029C8.60078 9.73164 8.66828 9.77773 8.75786 9.83887C8.85438 9.90504 8.97651 9.98902 9.12719 10.0929C9.41734 10.2932 9.65839 10.4551 9.85037 10.5788C10.0421 10.7025 10.2744 10.8407 10.5469 10.9942C10.8192 11.1475 11.076 11.2627 11.317 11.3394C11.5581 11.416 11.7813 11.4544 11.9866 11.4544H12H12.0133C12.2186 11.4544 12.4418 11.416 12.6829 11.3394C12.9239 11.2627 13.1805 11.1477 13.453 10.9942C13.7253 10.8407 13.9573 10.7022 14.1496 10.5788C14.3416 10.4551 14.5826 10.2932 14.8728 10.0929C15.0232 9.98902 15.1453 9.905 15.2418 9.83908C15.3315 9.77769 15.3989 9.73189 15.4421 9.7029C15.7333 9.50946 16.1872 9.20829 16.7974 8.80385C17.9077 8.06747 19.5429 6.98362 21.7099 5.54799C22.3616 5.11348 22.9061 4.58913 23.3437 3.97569C23.7805 3.36225 23.9995 2.71878 23.9995 2.04549C23.9995 1.48296 23.7872 1.00162 23.3634 0.600713C22.9392 0.200307 22.4369 0 21.8565 0Z",
  fill: "#0086CD"
}));

var _ref21 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 120 120",
  fill: "none",
  id: "icon_play"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 60,
  cy: 50,
  r: 40,
  fill: "#262626"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.4,
  cx: 60,
  cy: 50,
  r: 38.5,
  stroke: "#fff",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M78 50.5L50.25 66.5215L50.25 34.4785L78 50.5Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}))));

var _ref22 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 80 80",
  fill: "none",
  id: "icon_sad"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 80C17.9592 80 0 62.0408 0 40C0 17.9592 17.9592 0 40 0C62.0408 0 80 17.9592 80 40C79.9547 62.0408 62.0408 80 40 80ZM40 4.53515C20.4535 4.53515 4.53515 20.4535 4.53515 40C4.53515 59.5465 20.4535 75.4649 40 75.4649C59.5465 75.4649 75.4649 59.5465 75.4649 40C75.4195 20.4535 59.5465 4.53515 40 4.53515Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9794 29.2535C68.3445 29.2535 67.7549 28.8907 67.4828 28.2558C64.8978 21.6345 59.9998 16.1469 53.696 12.8363C52.925 12.4281 52.6075 11.4757 53.0157 10.7048C53.4239 9.93378 54.3762 9.61632 55.1472 10.0245C62.1314 13.698 67.5735 19.7297 70.4307 27.0766C70.7481 27.893 70.34 28.8 69.5237 29.1174C69.3876 29.2081 69.2062 29.2535 68.9794 29.2535Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.9818 10.5214C47.8458 10.5214 47.7097 10.5214 47.5736 10.4761C45.9863 10.0679 44.3084 9.75045 42.6757 9.61439C41.814 9.52369 41.1791 8.75272 41.2245 7.89104C41.2698 7.02936 42.0861 6.39443 42.9478 6.43978C44.7619 6.62119 46.6213 6.93865 48.39 7.39217C49.2516 7.61893 49.7505 8.4806 49.5238 9.34228C49.3423 10.0226 48.7074 10.5214 47.9818 10.5214Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9411 45.8939C22.4944 45.8939 19.6826 43.0821 19.6826 39.6354C19.6826 36.1887 22.4944 33.377 25.9411 33.377C29.3879 33.377 32.1996 36.1887 32.1996 39.6354C32.245 43.0821 29.4332 45.8939 25.9411 45.8939ZM25.9411 36.5062C24.2178 36.5062 22.8572 37.9121 22.8572 39.5901C22.8572 41.2681 24.2631 42.674 25.9411 42.674C27.6645 42.674 29.025 41.2681 29.025 39.5901C29.025 37.9121 27.6645 36.5062 25.9411 36.5062Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.469 45.8939C50.0222 45.8939 47.2104 43.0821 47.2104 39.6354C47.2104 36.1887 50.0222 33.377 53.469 33.377C56.9157 33.377 59.7275 36.1887 59.7275 39.6354C59.7275 43.0821 56.9157 45.8939 53.469 45.8939ZM53.469 36.5062C51.7456 36.5062 50.3851 37.9121 50.3851 39.5901C50.3851 41.2681 51.7909 42.674 53.469 42.674C55.147 42.674 56.5528 41.2681 56.5528 39.5901C56.5528 37.9121 55.147 36.5062 53.469 36.5062Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.9731 63.2201C51.3382 63.2201 50.7486 62.8572 50.5219 62.2677C48.7532 58.05 44.5808 55.2836 40.0003 55.2836C35.5559 55.2836 31.5196 57.8686 29.6602 61.9049C29.2974 62.7212 28.345 63.0387 27.574 62.6758C26.7577 62.313 26.4402 61.3607 26.8031 60.5897C29.2067 55.465 34.3768 52.1543 40.0457 52.1543C45.9414 52.1543 51.2022 55.6464 53.4697 61.0432C53.8326 61.8595 53.4244 62.7666 52.6081 63.1294C52.3813 63.1747 52.1546 63.2201 51.9731 63.2201Z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.7238 64.7174C58.2771 64.7174 55.4653 61.9056 55.4653 58.4589C55.4653 55.6471 59.5016 46.7129 60.3179 44.9441C60.59 44.3999 61.1343 44.0371 61.7692 44.0371C62.4041 44.0371 62.9483 44.3999 63.2204 44.9441C64.0368 46.7129 68.0731 55.6471 68.0731 58.4589C68.0277 61.9056 65.1706 64.7174 61.7238 64.7174ZM61.7238 49.5246C60.1365 53.1981 58.6399 57.2798 58.6399 58.4589C58.6399 60.1823 60.0458 61.5428 61.7238 61.5428C63.4018 61.5428 64.8077 60.1369 64.8077 58.4589C64.8531 57.2344 63.3111 53.1981 61.7238 49.5246Z",
  fill: "#EBEBEB"
}));

var _ref23 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "icon_search"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4883 14.5735L11.6803 10.6129C12.6594 9.44901 13.1959 7.98455 13.1959 6.45999C13.1959 2.89801 10.2979 0 6.73587 0C3.17389 0 0.275879 2.89801 0.275879 6.45999C0.275879 10.022 3.17389 12.92 6.73587 12.92C8.07309 12.92 9.34739 12.5167 10.4369 11.751L14.2738 15.7416C14.4342 15.9082 14.6499 16 14.8811 16C15.0999 16 15.3074 15.9166 15.465 15.7649C15.7998 15.4428 15.8105 14.9085 15.4883 14.5735ZM6.73587 1.68522C9.36874 1.68522 11.5107 3.82713 11.5107 6.45999C11.5107 9.09286 9.36874 11.2348 6.73587 11.2348C4.103 11.2348 1.96109 9.09286 1.96109 6.45999C1.96109 3.82713 4.103 1.68522 6.73587 1.68522Z",
  fill: "#EBEBEB"
}));

var _ref24 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 18",
  fill: "none",
  id: "icon_send-message"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0L0 10.125L5.75246 12.2555L14.625 3.93751L7.87626 13.0422L7.88175 13.0442L7.87502 13.0422V18L11.101 14.2365L15.1875 15.75L18 0Z",
  fill: "#0086CD"
}));

var _ref25 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 18",
  fill: "none",
  id: "icon_send-message-disabled"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0L0 10.125L5.75246 12.2555L14.625 3.93751L7.87626 13.0422L7.88175 13.0442L7.87502 13.0422V18L11.101 14.2365L15.1875 15.75L18 0Z",
  fill: "#EBEBEB"
}));

var _ref26 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 20 20",
  fill: "none",
  id: "instagram"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.45122 0.524497C2.79268 0.780646 2.23577 1.12218 1.67886 1.6792C1.12195 2.23216 0.780488 2.79325 0.52439 3.44785C0.276423 4.08213 0.109756 4.80992 0.0609756 5.87518C0.0121951 6.94043 0 7.28197 0 9.99797C0 12.714 0.0121951 13.0555 0.0609756 14.1208C0.109756 15.186 0.280488 15.9138 0.52439 16.5481C0.780488 17.2067 1.12195 17.7638 1.67886 18.3208C2.23577 18.8778 2.79268 19.2194 3.45122 19.4755C4.08537 19.7235 4.81301 19.8902 5.87805 19.939C6.94309 19.9878 7.28455 20 10 20C12.7154 20 13.0569 19.9878 14.122 19.939C15.187 19.8902 15.9146 19.7195 16.5488 19.4755C17.2073 19.2194 17.7642 18.8778 18.3211 18.3208C18.878 17.7638 19.2195 17.2067 19.4756 16.5481C19.7236 15.9138 19.8902 15.186 19.939 14.1208C19.9878 13.0555 20 12.714 20 9.99797C20 7.28197 19.9878 6.94043 19.939 5.87518C19.8902 4.80992 19.7195 4.08213 19.4756 3.44785C19.2195 2.79325 18.878 2.23216 18.3252 1.6792C17.7683 1.12218 17.2114 0.780646 16.5528 0.524497C15.9187 0.276479 15.1911 0.109778 14.126 0.060988C13.061 0.0121976 12.7195 0 10.0041 0C7.28862 0 6.94715 0.0121976 5.88211 0.060988C4.81301 0.105713 4.08537 0.276479 3.45122 0.524497ZM14.0406 1.8581C15.0163 1.90283 15.5447 2.06546 15.8984 2.2037C16.3659 2.38666 16.6992 2.60215 17.0488 2.95182C17.3984 3.30148 17.6138 3.63488 17.7967 4.10246C17.935 4.45619 18.0976 4.98475 18.1423 5.96056C18.1911 7.01362 18.1992 7.33076 18.1992 10.002C18.1992 12.6733 18.187 12.9904 18.1423 14.0435C18.0976 15.0193 17.935 15.5479 17.7967 15.9016C17.6138 16.3692 17.3984 16.7026 17.0488 17.0522C16.6992 17.4019 16.3659 17.6174 15.8984 17.8004C15.5447 17.9386 15.0163 18.1012 14.0406 18.146C12.9878 18.1948 12.6707 18.2029 10 18.2029C7.32927 18.2029 7.0122 18.1907 5.95935 18.146C4.98374 18.1012 4.45528 17.9386 4.10163 17.8004C3.63415 17.6174 3.30081 17.4019 2.95122 17.0522C2.60163 16.7026 2.38618 16.3692 2.20325 15.9016C2.06504 15.5479 1.90244 15.0193 1.85772 14.0435C1.80894 12.9904 1.80081 12.6733 1.80081 10.002C1.80081 7.33076 1.81301 7.01362 1.85772 5.96056C1.90244 4.98475 2.06504 4.45619 2.20325 4.10246C2.38618 3.63488 2.60163 3.30148 2.95122 2.95182C3.30081 2.60215 3.63415 2.38666 4.10163 2.2037C4.45528 2.06546 4.98374 1.90283 5.95935 1.8581C7.0122 1.80931 7.32927 1.80118 10 1.80118C12.6707 1.80118 12.9878 1.80931 14.0406 1.8581Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.86719 10.0021C4.86719 12.8401 7.168 15.1373 10.0013 15.1373C12.8347 15.1373 15.1355 12.836 15.1355 10.0021C15.1355 7.16822 12.8387 4.86694 10.0013 4.86694C7.16394 4.86694 4.86719 7.16416 4.86719 10.0021ZM13.3347 10.0021C13.3347 11.844 11.8428 13.3361 10.0013 13.3361C8.15987 13.3361 6.668 11.844 6.668 10.0021C6.668 8.1603 8.15987 6.66812 10.0013 6.66812C11.8428 6.66812 13.3347 8.1603 13.3347 10.0021Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.342 5.86309C16.0044 5.86309 16.5414 5.32609 16.5414 4.66366C16.5414 4.00124 16.0044 3.46423 15.342 3.46423C14.6796 3.46423 14.1426 4.00124 14.1426 4.66366C14.1426 5.32609 14.6796 5.86309 15.342 5.86309Z",
  fill: "#fff"
}));

var _ref27 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "linkedin"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.85796 1.86658C3.85796 2.90148 3.11347 3.73145 1.91673 3.73145H1.89388C0.742857 3.73145 0 2.89978 0 1.86658C0 0.80777 0.767347 0 1.93959 0C3.11347 0 3.8351 0.806062 3.85796 1.86658ZM0.200816 15.9983H3.63102V5.20525H0.200816V15.9983ZM12.0506 4.9525C10.2302 4.9525 9.41714 5.99765 8.95837 6.7354V6.76956H8.93551C8.94367 6.75931 8.95184 6.74736 8.95837 6.7354V5.20696H5.5298C5.57388 6.21795 5.5298 16 5.5298 16H8.96V9.97161C8.96 9.64713 8.98122 9.32778 9.07265 9.09553C9.32082 8.45341 9.88571 7.78226 10.831 7.78226C12.0735 7.78226 12.5714 8.77447 12.5714 10.2244V15.9983H16V9.81108C16 6.4929 14.3069 4.9525 12.0506 4.9525Z",
  fill: "#fff"
}));

var _ref28 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 24 24",
  fill: "none",
  id: "plus-unsafe"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C11.4477 0 11 0.447716 11 1V11H1C0.447715 11 0 11.4477 0 12C0 12.5523 0.447716 13 1 13H11V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H13V1C13 0.447715 12.5523 0 12 0Z",
  fill: "#E8E8E8"
}));

var _ref29 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 24 24",
  id: "remove-icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 4.9902344 3.9902344 A 1.0001 1.0001 0 0 0 4.2929688 5.7070312 L 10.585938 12 L 4.2929688 18.292969 A 1.0001 1.0001 0 1 0 5.7070312 19.707031 L 12 13.414062 L 18.292969 19.707031 A 1.0001 1.0001 0 1 0 19.707031 18.292969 L 13.414062 12 L 19.707031 5.7070312 A 1.0001 1.0001 0 0 0 18.980469 3.9902344 A 1.0001 1.0001 0 0 0 18.292969 4.2929688 L 12 10.585938 L 5.7070312 4.2929688 A 1.0001 1.0001 0 0 0 4.9902344 3.9902344 z",
  fill: "currentColor"
}));

var _ref30 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 15 16",
  fill: "none",
  id: "share"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.3313 10.3719C2.97452 10.3719 3.53733 10.1307 3.93934 9.72864L9.64788 13.0251C9.56748 13.1859 9.56748 13.4271 9.56748 13.5879C9.56748 14.9548 10.6127 16 11.9795 16C13.3464 16 14.3916 14.9548 14.3916 13.5879C14.3916 12.2211 13.3464 11.1759 11.9795 11.1759C11.3363 11.1759 10.7735 11.4171 10.3715 11.8191L4.66296 8.52261C4.74336 8.36181 4.74336 8.1206 4.74336 7.9598C4.74336 7.799 4.74336 7.55779 4.66296 7.39699L10.3715 4.0201C10.7735 4.42211 11.3363 4.66332 11.9795 4.66332C13.266 4.66332 14.3112 3.61809 14.3112 2.33166C14.3112 1.04523 13.266 9.53674e-07 11.9795 9.53674e-07C10.6931 9.53674e-07 9.64788 1.04523 9.64788 2.33166C9.64788 2.49246 9.64788 2.65327 9.72828 2.89447L4.01974 6.27136C3.61773 5.86935 3.05492 5.62814 2.4117 5.62814C1.04487 5.62814 -0.000359535 6.67337 -0.000359535 8.0402C-0.000359535 9.40704 0.964465 10.3719 2.3313 10.3719Z",
  fill: "#0086CD"
}));

var _ref31 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 18 12",
  id: "show"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 0.635254C5.56091 0.635254 2.44216 2.51681 0.140841 5.57296C-0.0469469 5.82335 -0.0469469 6.17315 0.140841 6.42353C2.44216 9.48337 5.56091 11.3649 9 11.3649C12.4391 11.3649 15.5578 9.48337 17.8592 6.42721C18.0469 6.17683 18.0469 5.82703 17.8592 5.57665C15.5578 2.51681 12.4391 0.635254 9 0.635254ZM9.2467 9.77793C6.96379 9.92154 5.07855 8.03998 5.22215 5.75339C5.33998 3.86815 6.86806 2.34007 8.7533 2.22224C11.0362 2.07864 12.9214 3.9602 12.7778 6.24679C12.6563 8.12835 11.1283 9.65642 9.2467 9.77793ZM9.13256 8.03261C7.90273 8.10994 6.88647 7.09736 6.96747 5.86753C7.03007 4.85127 7.85486 4.03016 8.87113 3.96388C10.101 3.88656 11.1172 4.89914 11.0362 6.12896C10.9699 7.14891 10.1451 7.97002 9.13256 8.03261Z"
}));

var _ref32 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 20 16",
  fill: "none",
  id: "twitter"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 1.89532C19.263 2.21561 18.4723 2.43306 17.6428 2.53003C18.4902 2.03049 19.1407 1.2371 19.445 0.293848C18.6514 0.758127 17.7741 1.09311 16.8402 1.2753C16.0913 0.490725 15.0261 0 13.8445 0C11.5799 0 9.74191 1.8101 9.74191 4.0404C9.74191 4.35776 9.77771 4.6663 9.84932 4.96015C6.43891 4.79265 3.41638 3.18237 1.39341 0.737557C1.04132 1.33407 0.838431 2.02755 0.838431 2.76804C0.838431 4.1697 1.56348 5.4068 2.66448 6.12966C1.99314 6.10909 1.36058 5.92691 0.805609 5.62424C0.805609 5.64187 0.805609 5.65657 0.805609 5.6742C0.805609 7.63122 2.2199 9.26501 4.09667 9.63526C3.75354 9.72635 3.38953 9.77631 3.01656 9.77631C2.75101 9.77631 2.49441 9.74986 2.24377 9.70285C2.76593 11.3073 4.28166 12.4768 6.07489 12.5091C4.66955 13.5934 2.90318 14.2399 0.978666 14.2399C0.647471 14.2399 0.322244 14.2193 0 14.184C1.81411 15.33 3.97136 16 6.28972 16C13.8356 16 17.9621 9.84389 17.9621 4.50468C17.9621 4.32837 17.9591 4.155 17.9502 3.98163C18.7528 3.41157 19.448 2.70046 19.997 1.88944L20 1.89532Z",
  fill: "#fff"
}));

var _ref33 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 16 16",
  fill: "none",
  id: "website"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5545 10.6318C15.8426 9.80721 15.9998 8.92167 15.9998 7.99996C15.9998 7.07825 15.8426 6.19271 15.5545 5.36809C15.5475 5.34332 15.5392 5.31916 15.5291 5.29592C14.4179 2.21146 11.4625 0 7.99989 0C4.53729 0 1.5818 2.21146 0.470717 5.29592C0.460625 5.31924 0.452215 5.34332 0.445258 5.36809C0.157186 6.19271 0 7.07825 0 7.99996C0 8.92167 0.157186 9.80721 0.445258 10.6318C0.452292 10.6566 0.460625 10.6808 0.470717 10.704C1.58187 13.7885 4.53729 15.9999 7.99989 15.9999C11.4625 15.9999 14.4179 13.7885 15.5291 10.704C15.5392 10.6808 15.5475 10.6567 15.5545 10.6318ZM7.99989 14.8532C7.69523 14.8532 7.20402 14.3018 6.79347 13.07C6.59531 12.4756 6.43667 11.7923 6.32107 11.0489H9.6787C9.56311 11.7923 9.40447 12.4755 9.20638 13.07C8.79576 14.3018 8.30455 14.8532 7.99989 14.8532ZM6.18193 9.90217C6.12681 9.2907 6.09768 8.65278 6.09768 7.99996C6.09768 7.34713 6.12681 6.70922 6.18193 6.09775H9.81777C9.87289 6.70922 9.90202 7.34713 9.90202 7.99996C9.90202 8.65278 9.87289 9.2907 9.81777 9.90217H6.18193ZM1.14671 8.00004C1.14671 7.34025 1.24067 6.70203 1.41551 6.09783H5.03171C4.97811 6.72191 4.9509 7.36151 4.9509 8.00004C4.9509 8.63856 4.97804 9.27816 5.03171 9.90224H1.41551C1.24067 9.29797 1.14671 8.65982 1.14671 8.00004ZM7.99989 1.14678C8.30455 1.14678 8.79583 1.69816 9.20638 2.92995C9.40447 3.52437 9.56318 4.2077 9.6787 4.95097H6.321C6.43659 4.20762 6.59523 3.52437 6.7934 2.92995C7.20402 1.69816 7.69523 1.14678 7.99989 1.14678ZM10.968 6.09783H14.5842C14.759 6.70203 14.853 7.34025 14.853 8.00004C14.853 8.65982 14.759 9.29804 14.5842 9.90224H10.968C11.0216 9.27816 11.0488 8.63856 11.0488 8.00004C11.0488 7.36151 11.0216 6.72191 10.968 6.09783ZM14.1361 4.95105H10.8364C10.6324 3.54455 10.2825 2.28271 9.79162 1.38501C11.6949 1.90098 13.2717 3.21833 14.1361 4.95105ZM6.20808 1.38493C5.71718 2.28263 5.36725 3.54448 5.16328 4.95105H1.8636C2.72805 3.21833 4.3048 1.90098 6.20808 1.38493ZM1.8636 11.0489H5.16328C5.36725 12.4554 5.71718 13.7173 6.20808 14.6151C4.3048 14.099 2.72805 12.7817 1.8636 11.0489ZM9.79162 14.6151C10.2825 13.7174 10.6324 12.4555 10.8364 11.0489H14.1361C13.2717 12.7817 11.6949 14.099 9.79162 14.6151Z",
  fill: "#262626"
}));

const SvgSprite = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 0,
  height: 0,
  style: {
    position: "absolute"
  },
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSprite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sprite.68096189.svg";
export { ForwardRef as ReactComponent };